const courses = [
  //McMaster Courses
  {
    university: "McMaster University",
    prefix: "ABLD",
    code: "3BA3",
    name: "Topics in Black, African and African Diaspora Studies",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ABLD",
    code: "3CD3",
    name: "Topics in the Black Caribbean and its Diasporas",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "1AA3",
    name: "Introduction to Anthropology: Sex, Food and Death",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "1AB3",
    name: "Introduction to Anthropology: Race, Religion, and Social Justice",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2AN3",
    name: "The Anthropology of Food and Nutrition",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2BB3",
    name: "Ancient Mesoamerica: Aztecs to Zapotecs",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2C03",
    name: "Archaeology of Environmental Crisis and Response",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2D03",
    name: "DNA Meets Anthropology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2DA3",
    name: "Traditional Indigenous Ecological Knowledge",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2E03",
    name: "Introduction to Biological Anthropology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2EE3",
    name: "Sport and/as Religion",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2F03",
    name: "Introduction to Sociocultural Anthropology: Listening Across Difference",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2FF3",
    name: "Human Skeletal Biology and Bioarchaeology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2G03",
    name: "Readings in Indo-European Myth",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2HE3",
    name: "Heritage, Economy, and Ethics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2HH3",
    name: "Science, Technology & Society: Archaeological Perspectives",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2HI3",
    name: "Medical Anthropology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2MA3",
    name: "Art and Activism",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2O03",
    name: "Themes in the Archaeological History of North America",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2PA3",
    name: "Introduction to Anthropological Archaeology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2PC3",
    name: "Aliens, Curses and Nazis: Archaeology and Hollywood",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2R03",
    name: "Religion, Magic and Witchcraft",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2RP3",
    name: "Religion and Power in the Past",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2U03",
    name: "Plagues and People",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "2WA3",
    name: "Neanderthals to Pyramids: Introduction to World Archaeology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3AR3",
    name: "Culture and Religion",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3AS3",
    name: "Archaeology and Society",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3BA3",
    name: "Special Topics in Biological Anthropology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3BB3",
    name: "Ancient Agriculture to Criminal Investigations: Paleoethnobotany in Practice",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3BD3",
    name: "The Black Death",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3BF3",
    name: "Bioarchaeological Field School",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3CA3",
    name: "Ceramic Analysis",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3CC6",
    name: "Archaeological Field School",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3DD3",
    name: "Archaeology of Death",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3E03",
    name: "Special Topics in Archaeology I",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3EE3",
    name: "Special Topics in Archaeology II",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3ET3",
    name: "Anthropology of Ethics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3F03",
    name: "Anthropology and the Humanities’",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3FA3",
    name: "Forensic Anthropology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3FF3",
    name: "Key Debates in Andean Archaeology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3G03",
    name: "Comparative Mythology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3GH3",
    name: "Interdisciplinary Global Health Field Course: Maternal and Infant Health in Morocco",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3HH3",
    name: "Globalization, Social Justice and Human Rights",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3IS3",
    name: "Independent Study in Anthropology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3K03",
    name: "Archaeological Interpretation",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3LA3",
    name: "Lithics Analysis",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3LL3",
    name: "Of Beauty and Violence",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3P03",
    name: "Doing Ethnography: Research Methods",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3PA3",
    name: "Haudenosaunee Health, Diet and Traditional Botany",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3PD3",
    name: "Anthropological Perspectives and Debates",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3PH3",
    name: "Dissent, Power and History",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3PP3",
    name: "Paleopathology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3SS3",
    name: "Sacred Journeys",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3ST3",
    name: "Anthropology of Postcolonial Science and Technology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3TR3",
    name: "The Anthropology of Tourism",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3W03",
    name: "Special Topics in Anthropology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3X03",
    name: "Zooarchaeology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "3Y03",
    name: "Indigenous Community Health and Wellbeing",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4AA3",
    name: "Materiality, Matter and Social Lives",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4AH3",
    name: "Archaeology and Heritage: Ethics, Politics, and Practice",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4B03",
    name: "Current Problems in Sociocultural Anthropology I",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4BB3",
    name: "Current Problems in Sociocultural Anthropology II",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4CC3",
    name: "Archaeology of Foodways",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4CL3",
    name: "Archaeology of Climate Change and Culture",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4CP3",
    name: "Cultural Politics of Food and Eating",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4D03",
    name: "Practicing Anthropology: Ethics, Theory, Engagement",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4DD3",
    name: "Anthropology of Zombies and the Undead",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4DN3",
    name: "Diet & Nutrition: Biocultural and Bioarchaeological Perspectives",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4E03",
    name: "Advanced Topics in Archaeology I",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4EE3",
    name: "Advanced Topics in Archaeology II",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4FF3",
    name: "Digging the City: The Archaeology of Urbanism",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4G03",
    name: "Independent Research I",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4GG3",
    name: "Independent Research II",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4GS3",
    name: "Genetics and Society",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4HF3",
    name: "Archaeology of Hunter-Fisher-Gatherers",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4HH3",
    name: "Archaeologies of Space and Place",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4J03",
    name: "Advanced Topics in Biological Anthropology I",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4JJ3",
    name: "Advanced Topics in Biological Anthropology II",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4KK3",
    name: "The Archaeology of Neanderthals and Humanities Early Humans",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4LL3",
    name: "Critical Global Health",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4MM3",
    name: "Borders, Migration, Refuge",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4R03",
    name: "Advanced Bioarchaeology and Skeletal Biology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4S03",
    name: "The Anthropology of Infectious Disease",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ANTHROP",
    code: "4SG3",
    name: "The Secret of the Gift",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARABIC",
    code: "2AA3",
    name: "Introduction to Modern Standard Arabic",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARABIC",
    code: "2AR3",
    name: "Introduction to Modern Standard Arabic II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARABIC",
    code: "3AA3",
    name: "Intermediate Modern Standard Arabic",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARABIC",
    code: "3GH3",
    name: "Spoken Moroccan Arabic",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "1TI3",
    name: "Making Art and Understanding Technology & Images",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "1UI3",
    name: "Making Art and Understanding Images",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "2AA3",
    name: "Introduction to the Practice of Art Therapy",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "2ER3",
    name: "Environmentally Responsible Art",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "3BA3",
    name: "Concentrated Study",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "3CC3",
    name: "Concentrated Study",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "3CF3",
    name: "Concentrated Study",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "3CI3",
    name: "Concentrated Study",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "3CL3",
    name: "Concentrated Study",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "3D03",
    name: "Practical Issues",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "3EA3",
    name: "Social Practice and Community-Engaged Art",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "3FW3",
    name: "Field Work: On-Site Explorations",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "3GS6",
    name: "Guided Studio Practice",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "3ID3",
    name: "Integrated Dimensional Media Concentration",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "3IM3",
    name: "Integrated Media Concentration",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "3PD3",
    name: "New Directions in Painting/drawing",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "3VA3",
    name: "Video Art and Digital Cinema",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "4AP3",
    name: "Contemporary Art Practices of Intervention, Performance and Conceptual Art",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "4AR3",
    name: "Advanced Research and Presentation Strategies",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "4AS6",
    name: "Advanced Studio Production and Critical Discourse",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "4CC3",
    name: "Concentrated Study",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "4CI3",
    name: "Concentrated Study",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "4CL3",
    name: "Concentrated Study",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "4EP3",
    name: "Exhibition Preparation and Documentation",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ART",
    code: "4PR3",
    name: "Professional Residency",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "2AA3",
    name: "Introduction to the Practice of Art Therapy",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "2B03",
    name: "Greek Art",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "2C03",
    name: "Roman Art",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "2DF3",
    name: "Art and Revolutions in France, 1789-1914",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "2FA3",
    name: "Film Analysis",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "2H03",
    name: "Aesthetics",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "2Y03",
    name: "Performance, Art and Visual Culture in the Middle East",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "2Z03",
    name: "Performance, Art and Visual Culture in East and South Asia",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "3AB3",
    name: "Applied Art History: Experiential Learning with Placement as an Intern",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "3B03",
    name: "Aspects of Canadian Art",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "3BB3",
    name: "Indigenous Art and Visual Culture in Canada, 1960 to the Present",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "3DF3",
    name: "Art and Politics in Second Empire France",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "3FL3",
    name: "Early Cinema History",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "3P03",
    name: "Issues in Studio Criticism",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "3Q03",
    name: "Colours of the World",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "3QQ3",
    name: "Greek Sanctuaries",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "3SS3",
    name: "Pompeii, Herculaneum, and Ostia",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "3XX3",
    name: "Cinema History from WWII",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "3Z03",
    name: "The Silk Road Visual Cultures",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "4AA3",
    name: "Seminar in Contemporary Art and Visual Culture",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "4AP3",
    name: "Contemporary Art Practices of Intervention, Performance and Conceptual Art",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "4E03",
    name: "Seminar in Art and Visual Culture 1400",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "4LP3",
    name: "The Cultural History of Paris, 1789-1914",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "4O06",
    name: "Thesis",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "4U03",
    name: "The Severe Style in Greek Art",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "4V03",
    name: "The Study, Criticism and Evaluation of Art",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "4X03",
    name: "Introduction to Art Galleries and Museums",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTHIST",
    code: "4Z03",
    name: "The Textile Arts",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "1A03",
    name: "Practices of Knowledge",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "1AA3",
    name: "Contemporary Indigenous Studies",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "1B03",
    name: "Writing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "1BB3",
    name: "Argumentation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "1C06",
    name: "Global Challenges Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "1D06",
    name: "Calculus",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "2A06",
    name: "Social and Political Thought",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "2D06",
    name: "Physics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "2E03",
    name: "Economics: Principles and Policy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "2R03",
    name: "Applied Statistical Inference",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "3B03",
    name: "Technology and Society I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "3BB3",
    name: "Technology and Society II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "3C03",
    name: "Coding Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "3CL3",
    name: "Theatre, Self, and Social Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "3CU3",
    name: "Alumni Experience Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "3DS1",
    name: "Deep Skills Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "3EH3",
    name: "Exploring Hamilton Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "3F03",
    name: "Experiential Project in Teaching and Learning",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "3GJ3",
    name: "Global Justice Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "3RL3",
    name: "Religion and Law",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "3S03",
    name: "The East Asian Religious Tradition",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "3TR3",
    name: "Trees and Their Histories",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "3X03",
    name: "Individual Study",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4A06",
    name: "Individual Study",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4A09",
    name: "Individual Study",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4C06",
    name: "Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4C09",
    name: "Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4CB3",
    name: "Education Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4CD3",
    name: "Research and Creative Writing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4CF3",
    name: "How Science Speaks to Power",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4CI3",
    name: "Diversity and Human Rights Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4CP3",
    name: "Media Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4CT3",
    name: "Medical Humanities Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4DS3",
    name: "Digital Society and Public Policy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4EP3",
    name: "Environmental Policy Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4HS3",
    name: "History of Science Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4LI3",
    name: "Literature Inquiry I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4LT3",
    name: "Literature Inquiry II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4MN1",
    name: "Local Explorations",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4MN2",
    name: "Movement and Integration",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4ST3",
    name: "Selected Topics in Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ARTSSCI",
    code: "4VC3",
    name: "Visual Culture Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ASTRON",
    code: "1F03",
    name: "Introduction to Astronomy and Astrophysics",
    classification: "Astronomy/Astrophysics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ASTRON",
    code: "2A03",
    name: "Perspectives on Indigenous and Eurocentric Astronomy",
    classification: "Astronomy/Astrophysics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ASTRON",
    code: "2B03",
    name: "The Big Questions",
    classification: "Astronomy/Astrophysics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ASTRON",
    code: "2E03",
    name: "Planetary Astronomy",
    classification: "Astronomy/Astrophysics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ASTRON",
    code: "3X03",
    name: "Galaxies and Cosmology",
    classification: "Astronomy/Astrophysics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ASTRON",
    code: "3Y03",
    name: "Stellar Structure",
    classification: "Astronomy/Astrophysics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ASTRON",
    code: "4X03",
    name: "Data Analysis Project Course",
    classification: "Astronomy/Astrophysics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ASTRON",
    code: "5X03",
    name: "Graduate Topics in Astrophysics",
    classification: "Astronomy/Astrophysics",
    lab: "",
  },

  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "2AC3",
    name: "Advanced CAD",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "2AE3",
    name: "Design of Machine Elements",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "2CD3",
    name: "Computer Aided Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "2MT3",
    name: "Structure and Properties of Materials",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "2TS3",
    name: "Thermodynamics and Heat Transfer",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "3AE3",
    name: "Automotive Engineering Technology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "3AV3",
    name: "Electric and Hybrid Vehicles",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "3CT3",
    name: "Control Theory",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "3MP3",
    name: "Manufacturing Processes and Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "3MV3",
    name: "Mechatronics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "3TS3",
    name: "Fluid Mechanics",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "3VD3",
    name: "Mechanical Vibrations",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "4AE3",
    name: "Internal Combustion Engines",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "4AT3",
    name: "Conceptual Design of Electric and Hybrid Vehicles",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "4CI3",
    name: "Robotics and Computer Integrated Manufacturing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "4DV3",
    name: "Vehicle Dynamics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "4EC3",
    name: "Electrical and Electronics Control Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "4MS3",
    name: "Kinematic and Dynamic Modelling and Simulation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "4TR1",
    name: "Capstone Design I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "AUTOTECH",
    code: "4TR3",
    name: "Capstone Design II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "2B03",
    name: "Nucleic Acid Structure and Function",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "2BB3",
    name: "Protein Structure and Enzyme Function",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "2EE3",
    name: "Metabolism and Physiological Chemistry",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "2L06",
    name: "Inquiry in Biochemical Techniques",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "3A03",
    name: "Biochemical Research Practice",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "3AB3",
    name: "Antibiotics are the Cornerstone of Medicine",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "3BP3",
    name: "Practical Bioinformatics in the Genomics Era",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "3CB3",
    name: "Emerging Discovery in Cell Biology",
    classification: "Cell Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "3D03",
    name: "Metabolism and Regulation",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "3G03",
    name: "Proteins and Nucleic Acids",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "3H03",
    name: "Clinical Biochemistry",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "3LA3",
    name: "Advanced Biochemistry Techniques",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "3LT3",
    name: "Fundamental and Applied Biochemical Techniques",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "3MI3",
    name: "Microbial Interactions",
    classification: "Microbiology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "3R03",
    name: "Clinical Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "3R06",
    name: "Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "3Z03",
    name: "Structural Determination and Analysis of Macromolecules",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "4C03",
    name: "Inquiry in Biochemistry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "4E03",
    name: "Gene Regulation in Stem Cells and Development",
    classification: "Genetics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "4F09",
    name: "Senior Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "4H03",
    name: "Biotechnology and Drug Discovery",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "4J03",
    name: "Immunological Principles in Practice",
    classification: "Immunology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "4M03",
    name: "Cellular and Integrated Metabolism",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "4N03",
    name: "Molecular Membrane Biology",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "4Q03",
    name: "Biochemical Pharmacology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "4S03",
    name: "Introduction to Molecular Biophysics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "4T15",
    name: "Senior Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOCHEM",
    code: "4Z03",
    name: "Senior Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "1A03",
    name: "Cellular and Molecular Biology",
    classification: "Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "1M03",
    name: "Biodiversity, Evolution and Humanity",
    classification: "Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "1P03",
    name: "Introductory Biology",
    classification: "Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "2A03",
    name: "Integrative Physiology of Animals",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "2B03",
    name: "Cell Biology",
    classification: "Cell Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "2C03",
    name: "Genetics",
    classification: "Genetics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "2D03",
    name: "Plant Biodiversity and Biotechnology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "2EE3",
    name: "Introduction to Microbiology and Biotechnology",
    classification: "Microbiology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "2F03",
    name: "Fundamental and Applied Ecology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "2L03",
    name: "The Scientific Method in Biology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3AA3",
    name: "Fundamental Concepts of Pharmacology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3B03",
    name: "Plant Physiology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3DD3",
    name: "Communities and Ecosystems",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3EI3",
    name: "Ecological Indicators",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3EP3",
    name: "Applied Biology Placement",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3ET3",
    name: "Ecotoxicology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3FF3",
    name: "Evolution",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3HD3",
    name: "Human Disasters",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3IR3",
    name: "Independent Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3JJ3",
    name: "Field Methods In Ecology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3MM3",
    name: "Invertebrate Form and Function",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3P03",
    name: "Cell Physiology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3PG3",
    name: "Population Genetics",
    classification: "Genetics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3R03",
    name: "Field Biology I",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3RF0",
    name: "Field Work I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3S03",
    name: "An Introduction to Bioinformatics",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3SA3",
    name: "Applied Statistics for Biology",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3SS3",
    name: "Population Ecology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3U03",
    name: "Animal Physiology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3UU3",
    name: "Animal Physiology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3XL3",
    name: "Comparative Vertebrate Anatomy & Physiology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "3ZZ3",
    name: "Topics in Physiology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "4A03",
    name: "Advanced Topics in Ecology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "4AA3",
    name: "Conservation Biology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "4AE3",
    name: "The Ecology and Evolution of Organisms",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "4C12",
    name: "Senior Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "4F06",
    name: "Senior Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "4IR3",
    name: "Advanced Independent Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "4J03",
    name: "Field Biology II",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "4JF0",
    name: "Field Work II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "4PP3",
    name: "Environmental Microbiology and Biotechnology",
    classification: "Microbiology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "4T03",
    name: "Molecular and Cellular Neuroscience",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOLOGY",
    code: "4X03",
    name: "Environmental Physiology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOMEDDC",
    code: "2C03",
    name: "Exploring Careers in Biomedical Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOMEDDC",
    code: "2W03",
    name: "Write Right for Your Science: Scientific Writing for the Biomedical Sciences",
    classification: "Writing",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOMEDDC",
    code: "3A03",
    name: "Ideas to Innovation in Biomedical Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOMEDDC",
    code: "3B06",
    name: "Drug Discovery and Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOMEDDC",
    code: "3C06",
    name: "Research Skills Laboratory and Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOMEDDC",
    code: "3C09",
    name: "Research Skills Laboratory and Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOMEDDC",
    code: "3WR3",
    name: "Biochemistry and Biomedical Scientific Writing: Right your Write",
    classification: "Writing",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOMEDDC",
    code: "4A15",
    name: "Senior Research Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOMEDDC",
    code: "4B03",
    name: "Road to Biomedical Commercialization",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOPHYS",
    code: "1S03",
    name: "Biophysics of Movement and the Senses: From Microbes to Moose",
    classification: "Biophysics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOPHYS",
    code: "2A03",
    name: "Biophysics of the Cell and Living Organisms",
    classification: "Biophysics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOPHYS",
    code: "2S03",
    name: "Explorations in Medical and Biological Physics",
    classification: "Biophysics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOPHYS",
    code: "3D03",
    name: "Origin of Life",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOPHYS",
    code: "3G03",
    name: "Modelling Life",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOPHYS",
    code: "3S03",
    name: "Soft Condensed Matter Physics",
    classification: "Biophysics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOPHYS",
    code: "4L03",
    name: "Literature Review",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOPHYS",
    code: "4P06",
    name: "Senior Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOPHYS",
    code: "4S03",
    name: "Introduction to Molecular Biophysics",
    classification: "Biophysics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "2B03",
    name: "Biotechnology Concepts",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "2BC3",
    name: "Biochemistry",
    classification: "Biochemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "2CB3",
    name: "Cell Biology",
    classification: "Cell Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "2EC3",
    name: "Chemical Engineering Concepts",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "2GT3",
    name: "Genetics",
    classification: "Genetics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "2M03",
    name: "Molecular Biology",
    classification: "Molecular Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "2MB3",
    name: "Microbiology",
    classification: "Microbiology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "2OC3",
    name: "Organic Chemistry",
    classification: "Organic Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "3B03",
    name: "Industrial Biotechnology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "3BC3",
    name: "Bioprocess Control and Dynamics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "3BP3",
    name: "Bioreactor Processes and Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "3CM3",
    name: "Computational Modeling of Biological Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "3FM3",
    name: "Food Microbiology",
    classification: "Microbiology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "3IV3",
    name: "Immunology and Virology",
    classification: "Immunology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "3PM3",
    name: "Pharmacology",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "4BI3",
    name: "Bioinformatics",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "4BL3",
    name: "Biomaterials and Biocompatibility",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "4BM3",
    name: "Biopharmaceuticals",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "4BS3",
    name: "Biotechnology Regulations",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "4GP3",
    name: "Genomics and Proteomics",
    classification: "Genetics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "4TB3",
    name: "Advanced Biotechnology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "4TR1",
    name: "Capstone Project I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "BIOTECH",
    code: "4TR3",
    name: "Capstone Project II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CAYUGA",
    code: "1Z03",
    name: "Introduction to Cayuga Language and Culture",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CAYUGA",
    code: "2Z03",
    name: "Intermediate Cayuga",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHALLENG",
    code: "2CC3",
    name: "Engineering and Science for Humanitys Critical Challenges",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "1A03",
    name: "Introductory Chemistry I",
    classification: "Inorganic/Introductory Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "1AA3",
    name: "Introductory Chemistry II",
    classification: "Inorganic/Introductory Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "1E03",
    name: "General Chemistry for Engineering I",
    classification: "Inorganic/Introductory Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "1R03",
    name: "General Chemistry",
    classification: "Inorganic/Introductory Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "2A03",
    name: "Quantitative Chemical Analysis",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "2BC3",
    name: "Making Chemistry More Sustainable",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "2E03",
    name: "Introductory Organic Chemistry",
    classification: "Organic Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "2II3",
    name: "Introductory Inorganic Chemistry: Structure and Bonding",
    classification: "Inorganic/Introductory Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "2LB3",
    name: "Tools for Chemical Discovery",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "2OA3",
    name: "Organic Chemistry I",
    classification: "Organic Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "2OB3",
    name: "Organic Chemistry II",
    classification: "Organic Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "2OD3",
    name: "Synthesis and Function of Organic Molecules",
    classification: "Organic Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "2OG3",
    name: "Structure and Reactivity of Organic Molecules",
    classification: "Organic Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "2P03",
    name: "Applications of Physical Chemistry",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "2Q03",
    name: "Inquiry for Chemistry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "2SC3",
    name: "Sustainable Chemistry",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "3AA3",
    name: "Instrumental Analysis",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "3EP3",
    name: "Advanced Chemistry Placement",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "3EQ3",
    name: "Experiential Sustainable Chemistry",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "3I03",
    name: "Industrial Chemistry",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "3II3",
    name: "Introduction to Transition Metal Chemistry",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "3LA3",
    name: "Strategies for Chemical Discovery",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "3OA3",
    name: "Organic Synthesis",
    classification: "Organic Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "3PA3",
    name: "Quantum Mechanics and Spectroscopy",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "3PC3",
    name: "Mathematical Tools for Chemical Problems",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "3RC3",
    name: "Radioisotopes in Medicine",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "3RP3",
    name: "Research Practicum in Chemistry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "3SC3",
    name: "Sustainable Chemistry: Natural Resources and Energy",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "4AA3",
    name: "Recent Advances in Analytical Chemistry",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "4D03",
    name: "Organic Structure and Synthesis",
    classification: "Organic Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "4G12",
    name: "Senior Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "4IA3",
    name: "Physical Methods of Inorganic Structure Determination",
    classification: "Inorganic/Introductory Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "4IB3",
    name: "Bio-Inorganic Chemistry",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "4IC3",
    name: "Solid State Inorganic Materials: Structures, Properties, Characterization and Applications",
    classification: "Inorganic/Introductory Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "4II3",
    name: "Transition Metal Organometallic Chemistry and Catalysis",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "4OA3",
    name: "Natural Products",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "4OB3",
    name: "Polymers and Organic Materials",
    classification: "Organic Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "4PB3",
    name: "Computational Models for Electronic Structure and Chemical Bonding",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "4Q03",
    name: "Peer Tutoring in Chemistry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "4RP6",
    name: "Research Project in Chemistry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "4SC3",
    name: "Sustainable Chemistry",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "4W03",
    name: "Natural and Synthetic Materials",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "2A03",
    name: "Introduction to Bio-Analytical Chemistry",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "2L03",
    name: "Pharmaceutical Chemistry Laboratory I: Biomolecular Interactions",
    classification: "Organic Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "2OD3",
    name: "Organic Chemistry II",
    classification: "Organic Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "2OG3",
    name: "Organic Chemistry I",
    classification: "Organic Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "2P03",
    name: "Physical Chemistry Tools for Chemical Biology",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "2Q03",
    name: "Inquiry for Chemical Biology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "3AA3",
    name: "Analytical Tools for Chemical Biology",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "3BM3",
    name: "Implanted Biomaterials",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "3EP3",
    name: "Advanced Chemical Biology Placement",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "3L03",
    name: "Chemical Biology Laboratory II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "3OA3",
    name: "Organic Mechanistic Tools for Chemical Biology",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "3OB3",
    name: "Structural Elucidation of Natural Products and Small Molecules",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "3P03",
    name: "Biomolecular Interactions and Kinetics",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "3RP3",
    name: "Research Practicum in Chemical Biology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "4A03",
    name: "Bio-Analytical Chemistry and Assay Development",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "4G12",
    name: "Senior Thesis in Chemical Biology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "4IB3",
    name: "Bio-Inorganic Chemistry",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "4OA3",
    name: "Natural Products",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "4OB3",
    name: "Medicinal Chemistry: Drug Design and Development",
    classification: "Other Advanced Chemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "4Q03",
    name: "Peer Tutoring in Chemical Biology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMBIO",
    code: "4RP6",
    name: "Research Project in Chemical Biology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEM",
    code: "5P06",
    name: "BMEIntegrated Chemical & Biomedical Engineering Capstone Design Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "2D04",
    name: "Chemical Engineering Principles I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "2E04",
    name: "Numerical Methods and Computing for Chemical Engineers",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "2F04",
    name: "Chemical Engineering Principles II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "2O04",
    name: "Fluid Mechanics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "3A04",
    name: "Heat Transfer",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "3BK3",
    name: "Bio-Reaction Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "3BM3",
    name: "Bioseparations Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "3D04",
    name: "Chemical Engineering Thermodynamics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "3G04",
    name: "Chemical Process Design and Simulation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "3I03",
    name: "Data Acquisition and Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "3K04",
    name: "Introduction to Reactor Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "3L03",
    name: "Intermediate Laboratory Skills",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "3M04",
    name: "Mass Transfer and Stagewise Operations",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "3P04",
    name: "Process Control",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "3Q03",
    name: "Introduction to Polymer Science",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4A03",
    name: "Energy Systems Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4B03",
    name: "Polymer Reaction Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4E03",
    name: "Digital Computer Process Control",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4EC3",
    name: "Electrochemistry and Electrochemical Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4G03",
    name: "Optimization in Chemical Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4H03",
    name: "Big Data Methods and Modeling in Chemical and Materials Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4K03",
    name: "Reactor Design for Heterogeneous Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4L03",
    name: "Advanced Laboratory Skills",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4M03",
    name: "Industrial Separation Processes",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4N04",
    name: "Engineering Economics and Problem Solving",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4T03",
    name: "Applications of Chemical Engineering in Medicine",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4W06",
    name: "Chemical Plant Design and Capstone Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4X03",
    name: "Polymer Processing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4Y04",
    name: "Senior Independent Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHEMENG",
    code: "4Z03",
    name: "Interfacial Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CHINESE",
    code: "1Z06",
    name: "Mandarin Chinese for Beginners",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVBME",
    code: "5P06",
    name: "Integrated Civil & Biomedical Engineering Capstone Design Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "2A03",
    name: "Surveying and Measurement for Transportation and Construction",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "2B04",
    name: "Principles of Environmental Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "2C04",
    name: "Structural Mechanics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "2E03",
    name: "Computer Applications in Civil Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "2J03",
    name: "Engineering Geology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "2O04",
    name: "Fluid Mechanics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "2P04",
    name: "Statics and Mechanics of Materials",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "2Q03",
    name: "Engineering Mechanics: Dynamics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "3A03",
    name: "Geotechnical Engineering I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "3B03",
    name: "Geotechnical Engineering II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "3C03",
    name: "Engineering Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "3G04",
    name: "Structural Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "3J04",
    name: "Reinforced Concrete Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "3K03",
    name: "Introduction to Transportation Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "3L03",
    name: "Water Quality",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "3M03",
    name: "Municipal Hydraulics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "3P04",
    name: "Civil Engineering Materials and Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4A04",
    name: "Engineering Hydrology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4BP4",
    name: "Building Science",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4CA4",
    name: "Construction Management and Automation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4DD4",
    name: "Structural Dynamics and Seismic Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4G04",
    name: "Pavement Materials and Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4K04",
    name: "Modern Methods of Structural Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4L04",
    name: "Design of Water Resources Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4N04",
    name: "Steel Structures",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4P04",
    name: "Physical Hydrogeology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4S04",
    name: "Foundation Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4SM4",
    name: "Stormwater Management Modeling and Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4T04",
    name: "Transit Modelling and Intelligent Transportation Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4TA4",
    name: "Traffic Analysis: Theory and Simulation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4V04",
    name: "Biological Aspects of Wastewater Treatment",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4W04",
    name: "Design of Low Rise Buildings",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4X06",
    name: "Design and Synthesis Project in Civil Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4Y04",
    name: "Bridges and Other Structural Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVENG",
    code: "4Z04",
    name: "Independent Study",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVTECH",
    code: "3GE3",
    name: "Geotechnical Materials and Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVTECH",
    code: "3GT3",
    name: "Geotechnical Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVTECH",
    code: "3PM3",
    name: "Highway Design, Construction, and Maintenance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVTECH",
    code: "3SA3",
    name: "Structural Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVTECH",
    code: "3TP3",
    name: "Transportation Planning and Modelling",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVTECH",
    code: "4BC3",
    name: "Building Science",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVTECH",
    code: "4BD3",
    name: "Bridge Design, Maintenance and Repair",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVTECH",
    code: "4LU3",
    name: "Advanced Land Use Planning",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVTECH",
    code: "4MH3",
    name: "Hydraulic Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVTECH",
    code: "4RC3",
    name: "Reinforced Concrete and Masonry Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVTECH",
    code: "4SD3",
    name: "Structural Steel Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVTECH",
    code: "4UM3",
    name: "Asset Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CIVTECH",
    code: "4WT3",
    name: "Municipal and Environmental Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "1A03",
    name: "Introduction to Communication",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "2BB3",
    name: "Culture and Communication",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "2DD3",
    name: "Media Organizations",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "2EM3",
    name: "Environmental Media",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "2G03",
    name: "Performance and Performativity",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "2H03",
    name: "Gender and Performance",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "2HM3",
    name: "Human Communication",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "2K03",
    name: "Political Economy of the Media",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "2LW3",
    name: "Communication Policy and Law",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "2PR3",
    name: "Public Relations: Principles and Practices",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "2RA3",
    name: "Application in Communication Theory and Methods",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "2TM6",
    name: "Foundations in Communication Theory and Methods",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3B03",
    name: "Practical Aspects of Media Production",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3CY3",
    name: "Children, Youth, and Media",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3D03",
    name: "Political Communication",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3DG3",
    name: "Digital Storytelling",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3DJ3",
    name: "Digital Justice",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3HC3",
    name: "History of Communication",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3II3",
    name: "Intellectual Property",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3JJ3",
    name: "The Rise of the Music Industry",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3K03",
    name: "Media Audiences and Effects",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3PM3",
    name: "Public Memory, Media, and African Diaspora Studies",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3RR3",
    name: "Race, Religion and Media",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3S03",
    name: "Television and Society",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3SM3",
    name: "Building Publics Using Social Media",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3WC3",
    name: "World Cinemas: Critical Media Approaches",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3WR3",
    name: "Professional Writing",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "3Z03",
    name: "Mobile Practices, Technologies and Art",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "4A03",
    name: "Independent Research Project",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "4D03",
    name: "International Communication",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "4E03",
    name: "Media and Promotionalism",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "4M03",
    name: "Communication, Culture and Technology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "4N03",
    name: "News Analysis: Theory and Practice",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "4P03",
    name: "Social Activism and the Media",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "4Q03",
    name: "Broadcasting Transformation in A Multimedia Era",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMST",
    code: "4X03",
    name: "Communications for Campaigns and Elections",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMTYENGA",
    code: "2A03",
    name: "Foundations of Community Engagement",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMTYENGA",
    code: "2MC3",
    name: "Design and Creation of Engaged Learning for Community Youth",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMTYENGA",
    code: "2MD3",
    name: "Community-Based Learning with McMaster Children and Youth University",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMTYENGA",
    code: "3A03",
    name: "The Art of Change",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMTYENGA",
    code: "4A06",
    name: "Semester at CityLAB: Design and Dialogue Inquiry",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMTYENGA",
    code: "4A09",
    name: "Semester at CityLAB: Applied Project Experience",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "CMTYENGA",
    code: "4MM3",
    name: "Collaborative Learning with Young People: An Applied Approach",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "1AS3",
    name: "Aging and Society",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "1F03",
    name: "Political Structures and Issues",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "1G03",
    name: "Multiculturalism",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "2A03",
    name: "Abnormal Psychology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "2C03",
    name: "Sociology I",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "2D03",
    name: "Human Sexuality",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "2G03",
    name: "Quest for Meaning",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "2I03",
    name: "The Uses of Laughter: Comedy and Satire",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "2K03",
    name: "Introduction to Health Informatics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "2M03",
    name: "Medical Anthropology: Illness and Healthcare in Cross-Cultural Perspective and Social Issues",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "2N03",
    name: "Organizational Behaviour",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "2P03",
    name: "Epidemiology in Public Health",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "2R03",
    name: "Epidemiological Methods",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "2T03",
    name: "Aging in Place",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "3B03",
    name: "Sociology: Diversity and Inequality",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "3IP3",
    name: "Interprofessional Case Management",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COLLAB",
    code: "4H03",
    name: "Introduction to Concepts in Global Health",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "1AA3",
    name: "Introductory Financial Accounting",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "1B03",
    name: "Business Environment & Organization",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "1BA3",
    name: "Organizational Behaviour",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "1DA3",
    name: "Business Data Analytics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "1DE0",
    name: "Business I Orientation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "1E03",
    name: "Business Environment and Organization",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "1GR0",
    name: "DeGroote Student Experience and Development I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "1MA3",
    name: "Introduction to Marketing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "1TS0",
    name: "Orientation for New Transfer Students",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "2AB3",
    name: "Managerial Accounting I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "2BC3",
    name: "Human Resource Management and Labour Relations",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "2DA3",
    name: "Decision Making with Analytics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "2FA3",
    name: "Introduction to Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "2FB3",
    name: "Managerial Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "2GR0",
    name: "DeGroote Student Experience and Development II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "2IN0",
    name: "Career Development Course",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "2KA3",
    name: "Information Systems in Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "2MA3",
    name: "Introduction to Marketing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "2NG3",
    name: "Negotiations",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "2OC3",
    name: "Operations Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "2QA3",
    name: "Applied Statistics for Business",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3AB3",
    name: "Intermediate Financial Accounting I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3AC3",
    name: "Intermediate Financial Accounting II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3DA3",
    name: "Predictive Analytics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3FA3",
    name: "Managerial Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3FB3",
    name: "Securities Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3FC3",
    name: "International Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3FD3",
    name: "Financial Modelling",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3FH3",
    name: "Alternative Investments and Portfolio Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3FI3",
    name: "Market Trading with Options and Futures",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3FK3",
    name: "Intermediate Corporate Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3FL3",
    name: "Sustainable and Social Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3FM3",
    name: "The History of Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3FN3",
    name: "Big Data in Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3GR0",
    name: "DeGroote Student Experience and Development III",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3KA3",
    name: "System Analysis and Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3KD3",
    name: "Database Design Management and Applications",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3KE3",
    name: "Management of Enterprise Data Analytics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3MA3",
    name: "Marketing Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3MB3",
    name: "Consumer Behaviour",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3MC3",
    name: "Applied Marketing Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3MD3",
    name: "Introduction to Contemporary Applied Marketing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3QA3",
    name: "Management Science for Business",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "3S03",
    name: "Management Skills Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4AA3",
    name: "Managerial Accounting II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4AC3",
    name: "Advanced Financial Accounting",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4AD3",
    name: "Introduction to Auditing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4AF3",
    name: "Accounting Theory",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4AK3",
    name: "Accounting Information for Decision Making",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4BB3",
    name: "Recruitment and Selection",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4BC3",
    name: "Collective Bargaining",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4BD3",
    name: "Settlement of Industrial Disputes",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4BE3",
    name: "Strategic Compensation/Reward Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4BF3",
    name: "Labour Law and Policy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4BG3",
    name: "Public Sector Collective Bargaining",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4BI3",
    name: "Training and Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4BK3",
    name: "The Management of Technology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4BL3",
    name: "Occupational Health and Safety Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4BM3",
    name: "Strategic Human Resource Planning",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4BN3",
    name: "Leadership Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4BP3",
    name: "Principles of Leadership",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4BQ3",
    name: "Social Entrepreneurship",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4BX3",
    name: "Special Topics in Human Resource Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4CA3",
    name: "Managing and Promoting Health and Healthcare Services",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4DA3",
    name: "Modelling and Prescriptive Analytics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4EL3",
    name: "Experiential Learning in Business",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FA3",
    name: "Applied Corporate Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FB3",
    name: "Valuation for Finance Professionals",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FC3",
    name: "Ethics and Professional Practice in Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FD3",
    name: "Financial Institutions",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FE3",
    name: "Options and Futures",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FF3",
    name: "Portfolio Theory and Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FG3",
    name: "Financial Theory",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FH3",
    name: "Mergers, Acquisitions and Corporate Control",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FJ3",
    name: "Fixed Income Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FK3",
    name: "Financial Statement Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FL3",
    name: "Personal Financial Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FM3",
    name: "Personal Financial Planning and Advising",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FN3",
    name: "Financial Risk Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FO3",
    name: "Small Business and Entrepreneurial Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FP3",
    name: "Personal Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FQ3",
    name: "Working Capital Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FR3",
    name: "Insurance and Risk Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FS3",
    name: "Pension, Retirement and Estate Planning",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FT3",
    name: "Real Estate Finance and Investment",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FU3",
    name: "Behavioural Finance: The Psychology of Markets",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FV3",
    name: "Venture Capital",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FW3",
    name: "Finance for Entrepreneurs",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FX3",
    name: "Special Topics in Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FY3",
    name: "Introduction to FinTech",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4FZ3",
    name: "Islamic Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4GR3",
    name: "DeGroote Student Experience and Development IV",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4IA0",
    name: "Internship 1",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4IB0",
    name: "Internship 2",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4IC0",
    name: "Internship 3",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4ID0",
    name: "Internship Final Term",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4KF3",
    name: "Project Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4KG3",
    name: "Data Mining For Business Analytics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4KH3",
    name: "Strategies for Electronic and Mobile Business",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4KI3",
    name: "Business Process Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4KX3",
    name: "Special Topics in Information Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4MA3",
    name: "Advertising and Integrated Marketing Communication",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4MC3",
    name: "New Product Marketing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4MD3",
    name: "Business Marketing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4ME3",
    name: "Sales Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4MF3",
    name: "Retailing Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4MG3",
    name: "Strategic Philanthropy and Leadership",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4MH3",
    name: "Digital Marketing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4MI3",
    name: "Marketing Analytics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4OB3",
    name: "Analysis of Production/Operations Problems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4OD3",
    name: "Purchasing and Supply Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4OI3",
    name: "Supply Chain Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4OT3",
    name: "Transportation and Warehousing Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4PA3",
    name: "Business Policy: Strategic Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4QA3",
    name: "Operations Modelling and Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4QX3",
    name: "Special Topics in Operations Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4SA3",
    name: "International Business",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4SB3",
    name: "Introduction to Canadian Taxation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4SC3",
    name: "Advanced Canadian Taxation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4SD3",
    name: "Commercial Law",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4SE3",
    name: "Entrepreneurship",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4SG3",
    name: "Sustainability: Corporations and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4SH3",
    name: "Case Analysis and Presentation Skills",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4SI3",
    name: "Innovation for Social Impact",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4SM3",
    name: "Sports Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4SX3",
    name: "Special Topics in Strategic Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMMERCE",
    code: "4SY3",
    name: "Independent Study in Business",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "2DI4",
    name: "Logic Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "2DX3",
    name: "Microprocessor Systems Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "2SH4",
    name: "Principles of Programming",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "2SI3",
    name: "Data Structures and Algorithms",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "3DQ5",
    name: "Digital Systems Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "3DY4",
    name: "Computer Systems Integration Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "3SK3",
    name: "Computer-Aided Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "3SM4",
    name: "Algorithm Design and Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "4DK4",
    name: "Computer Communication Networks",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "4DM4",
    name: "Computer Architecture",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "4DN4",
    name: "Advanced Internet Communications",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "4DS4",
    name: "Embedded Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "4OH4",
    name: "Advanced Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "4OJ4",
    name: "Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "4SL4",
    name: "Fundamentals of Machine Learning",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "4TL4",
    name: "Digital Signal Processing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPENG",
    code: "4TN4",
    name: "Image Processing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "1DM3",
    name: "Discrete Mathematics for Computer Science",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "1JC3",
    name: "Introduction to Computational Thinking",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "1MD3",
    name: "Introduction to Programming",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "1TA3",
    name: "Elementary Computing and Computer Use",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "1XC3",
    name: "Computer Science Practice and Experience: Development Basics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "1XD3",
    name: "Computer Science Practice and Experience: Introduction to Software Design Using Web Programming",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "2AC3",
    name: "Automata and Computability",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "2C03",
    name: "Data Structures and Algorithms",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "2DB3",
    name: "Databases",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "2GA3",
    name: "Computer Architecture",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "2LC3",
    name: "Logical Reasoning for Computer Science",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "2ME3",
    name: "Introduction to Software Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "2SD3",
    name: "Concurrent Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "2XC3",
    name: "Computer Science Practice and Experience: Algorithms and Software Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "3AC3",
    name: "Algorithms and Complexity",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "3DM3",
    name: "Introduction to Data Mining",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "3DP3",
    name: "Data Privacy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "3EA3",
    name: "Software and System Correctness",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "3GC3",
    name: "Computer Graphics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "3IS3",
    name: "Information Security",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "3MI3",
    name: "Principles of Programming Languages",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "3N03",
    name: "Computer Networks and Security",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "3RA3",
    name: "Software Requirements and Security Considerations",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "3SH3",
    name: "Computer Science Practice and Experience: Operating Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "3TB3",
    name: "Syntax-Based Tools and Compilers",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4AD3",
    name: "Advanced Databases",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4AR3",
    name: "Software Architecture",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4C03",
    name: "Computer Networks and Security",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4DC3",
    name: "Distributed Computing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4E03",
    name: "Performance Analysis of Computer Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4EN3",
    name: "Software Entrepreneurship",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4F03",
    name: "Parallel Computing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4FP3",
    name: "Functional Programming",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4HC3",
    name: "Human Computer Interfaces",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4ML3",
    name: "Introduction to Machine Learning",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4O03",
    name: "Linear Optimization",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4TB3",
    name: "Syntax-Based Tools and Compilers",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4TE3",
    name: "Continuous Optimization",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4TH3",
    name: "Theory of Computation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4TI3",
    name: "Fundamentals of Image Processing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4WW3",
    name: "Web Systems and Web Computing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4X03",
    name: "Scientific Computation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4Z03",
    name: "Directed Readings",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "COMPSCI",
    code: "4ZP6",
    name: "Capstone Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "DATASCI",
    code: "2G03",
    name: "Scientific Computing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "DATASCI",
    code: "3ML3",
    name: "Introduction to Neural Networks and Machine Learning",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "DATASCI",
    code: "4X03",
    name: "Data Analysis Project Course",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "1G03",
    name: "Earth and the Environment",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "2E03",
    name: "Earth History",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "2FE3",
    name: "Introduction to Field Methods in Earth Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "2G03",
    name: "Earth Surface Process",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "2GG3",
    name: "Natural Disasters",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "2K03",
    name: "Optical Crystallography and Mineralogy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "2T03",
    name: "Geology of Canada",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "3CC3",
    name: "Earth’s Changing Climate",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "3E03",
    name: "Sedimentary Environments",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "3FE3",
    name: "Field Camp",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "3K03",
    name: "Petrology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "3P03",
    name: "Paleoecology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "3RD3",
    name: "Research Design and Dissemination in Earth and Environmental Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "3V03",
    name: "Environmental Geophysics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "3W03",
    name: "Physical Hydrogeology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "3Z03",
    name: "Structural Geology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "4CC3",
    name: "Stable Isotopes in Earth and Environmental Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "4FF3",
    name: "Topics of Field Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "4G03",
    name: "Glacial Sediments and Environments",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "4MT6",
    name: "Senior Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "4PA3",
    name: "Paleoenvironmental Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "4T03",
    name: "Plate Tectonics and Ore Deposits",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "4V03",
    name: "Exploration Geophysics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EARTHSC",
    code: "4WB3",
    name: "Contaminant Hydrogeology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "1B03",
    name: "Introductory Microeconomics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "1BB3",
    name: "Introductory Macroeconomics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "1ME3",
    name: "Introduction to Mathematical Economics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2A03",
    name: "Economics of Labour-Market Issues",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2B03",
    name: "Analysis of Economic Data",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2CC3",
    name: "Health Economics and its Application to Health Policy",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2D03",
    name: "Economic Issues",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2H03",
    name: "Intermediate Macroeconomics I",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2HH3",
    name: "Intermediate Macroeconomics II",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2I03",
    name: "Financial Economics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2J03",
    name: "Environmental Economics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2K03",
    name: "Economic History of Canada",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2N03",
    name: "Public Policy Toward Business",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2P03",
    name: "Economics of Professional Sports",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2Q03",
    name: "Economics of Bad Behaviour",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2T03",
    name: "Economics of Trade Unionism and Labour",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2Z03",
    name: "Intermediate Microeconomics I",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "2ZZ3",
    name: "Intermediate Microeconomics II",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3B03",
    name: "Public Sector Economics: Expenditures",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3BE3",
    name: "Behavioural Economics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3C03",
    name: "Public Sector Economics: Taxation",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3D03",
    name: "Labour Economics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3E03",
    name: "Applied Econometrics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3EE3",
    name: "Econometrics I",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3G03",
    name: "Introduction to Advanced Economic Theory",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3H03",
    name: "International Monetary Economics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3HH3",
    name: "International Trade",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3K03",
    name: "Monetary Economics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3M03",
    name: "Introduction to Game Theory",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3Q03",
    name: "The Economics of Aging",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3S03",
    name: "Industrial Organization",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3T03",
    name: "Economic Development",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3W03",
    name: "Natural Resources",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3Y03",
    name: "Selected Topics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "3Z03",
    name: "Health Economics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "4A03",
    name: "Honours Economic Analysis",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "4AA3",
    name: "Economic Specialist Seminar",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "4B03",
    name: "Selected Topics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "4F03",
    name: "Methods of Inquiry in Economics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "4FF3",
    name: "Research Methods in Economics",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "4G03",
    name: "Econometrics II",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "4M06",
    name: "Directed Research I",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "4N03",
    name: "Directed Research II",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "4T03",
    name: "Advanced Economic Theory I",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ECON",
    code: "4TT3",
    name: "Advanced Economic Theory II",
    classification: "Economics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECBME",
    code: "5P06",
    name: "Integrated Electrical & Biomedical Engineering Capstone Design Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "2CF3",
    name: "Circuits and Waves",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "2CI4",
    name: "Introduction to Electrical Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "2CJ4",
    name: "Circuits and Systems",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "2EI4",
    name: "Electronic Devices and Circuits I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "2FH4",
    name: "Electromagnetics I",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "2MM3",
    name: "Electrical Circuits and Power",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "3CL4",
    name: "Introduction to Control Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "3EJ4",
    name: "Electronic Devices and Circuits II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "3EY4",
    name: "Electrical Systems Integration Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "3FK4",
    name: "Electromagnetics II",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "3N03",
    name: "Electronics and Instrumentation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "3PI4",
    name: "Energy Conversion",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "3TP3",
    name: "Signal & Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "3TQ3",
    name: "Advanced Probability and Random Processes",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "3TR4",
    name: "Communication Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4BB3",
    name: "Cellular Bioelectricity",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4BD4",
    name: "Biomedical Instrumentation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4BF4",
    name: "Advanced Medical Imaging",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4CL4",
    name: "Control System Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4EK4",
    name: "Microelectronics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4EM4",
    name: "Photonic Devices and Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4FJ4",
    name: "Devices and Antennas for Wireless Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4OH4",
    name: "Advanced Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4OI6",
    name: "Engineering Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4OJ4",
    name: "Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4PK4",
    name: "Power Electronics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4PM4",
    name: "Electrical Power Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4PN4",
    name: "Electric Motor Drives",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4PP4",
    name: "Smart and Micro Grids",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ELECENG",
    code: "4TK4",
    name: "Digital Communications Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGINEER",
    code: "1EE0",
    name: "Introduction to the Engineering Co-op Program",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGINEER",
    code: "1P13",
    name: "Integrated Cornerstone Design Projects in Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGINEER",
    code: "1PA3",
    name: "Introduction to Engineering Design and Practice",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGINEER",
    code: "1PB3",
    name: "Structure and Properties of Materials",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGINEER",
    code: "1PC3",
    name: "Engineering Computation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGINEER",
    code: "2EC0",
    name: "Engineering Work Term",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGINEER",
    code: "2IW3",
    name: "Inclusion in the Engineering Workplace",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGINEER",
    code: "2PX3",
    name: "Engineering Design 2: Communications and Social Impact",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGINEER",
    code: "3CX3",
    name: "Experiential Learning in Complementary Studies",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGINEER",
    code: "3IC0",
    name: "Full-Time Internship for International Students",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGINEER",
    code: "3PX3",
    name: "Engineering Design 3: Engineering Economics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGINEER",
    code: "4A03",
    name: "Ethics, Equity and Law in Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGINEER",
    code: "4EX3",
    name: "Experiential Engineering Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "1CS3",
    name: "Studying Culture: A Critical Introduction",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "1F03",
    name: "The Written World",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "1G03",
    name: "Making and Unmaking Literary Traditions",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "1H03",
    name: "Words in Place",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2AA3",
    name: "American Literature and Culture Before 1900",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2BB3",
    name: "American Literature and Culture After 1900",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2BL3",
    name: "Twentieth- and Twenty-First Century British Literature and Film",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2C03",
    name: "Contemporary Canadian Fiction",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2CC3",
    name: "Settler Colonialism and Writing in Canada",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2CL3",
    name: "Canadian Literature of Dissent and Social Justice",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2CR3",
    name: "Shakespeare: Comedies, Problem Plays, and Romances",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2CW3",
    name: "Genre in Creative Writing",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2HT3",
    name: "Shakespeare: Histories and Tragedies",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2KA3",
    name: "Indigenous Futurisms and Wonderworks",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2KK3",
    name: "Studies in Women Writers",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2M03",
    name: "Concepts of Culture",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2NH3",
    name: "Narratives of Health",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2PC3",
    name: "Popular Culture",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2TP3",
    name: "Literary and Cultural Studies: Theory and Practice",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2VC3",
    name: "Topics in Visual Culture",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "2Z03",
    name: "Reading Environmental Humanities",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3A03",
    name: "Critical Race Studies",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3AA3",
    name: "Theories of Gender and Sexuality",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3CP3",
    name: "Writing Practices",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3CR3",
    name: "Writing Out",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3CW3",
    name: "Creating Writing in/for/with Communities",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3EC3",
    name: "Enlightenment and its Shadows",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3GF3",
    name: "Topics in Popular Genres",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3GG3",
    name: "Theories of Decolonization and Resistance",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3GS3",
    name: "Reading the Embodied Past: Gender and Sexuality",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3H03",
    name: "Jane Austen",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3NH3",
    name: "Narratives of Health",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3QQ3",
    name: "Contemporary Critical Theory",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3RW3",
    name: "Reading and Writing in the Field: Experiential Learning in Theory and Practice",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3V03",
    name: "Global Anglophone Literature and Film",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3VC3",
    name: "‘We Other Victorians’: Victorian Literature and Culture and Its Afterlives",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3W03",
    name: "Contemporary Native Literature in Canada",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3WE3",
    name: "British Romantic Literature and Culture: Revolution, War, Empire",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "3X03",
    name: "Contemporary Native Literature in the United States",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4AN3",
    name: "Nineteenth-Century Adaptations",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4CA3",
    name: "Under the Gaze of the Nonhuman: Critical Animal Studies",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4CC3",
    name: "Creative Writing Capstone",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4CF3",
    name: "Contemporary Fiction",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4DL3",
    name: "Digital Lives",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4E03",
    name: "Literature, Culture and Climate Catastrophe",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4ED3",
    name: "Windrush Writing/Writing Windrush: Empire, Race and Decolonization",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4FW3",
    name: "Forms of Creative Writing",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4GN3",
    name: "Graphic Narrative in Canada",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4IW3",
    name: "Twenty-First Century Indigenous Writing and Film",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4LF3",
    name: "Diné and Dene Literature and Film",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4ML3",
    name: "What is Millennial Literature?",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4QA3",
    name: "Queerness in the Archives: Lesbian and Gay Writing, Art and Activism in Canada, 1969-1989",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4RD3",
    name: "Renaissance Drama, Excluding Shakespeare",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4RI3",
    name: "Colonialism and Resistance in Representations of Indigenous Womanhood",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4RS3",
    name: "Reading, Spirituality and Cultural Politics",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4SD3",
    name: "Sentenced to Death",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4ST3",
    name: "Even Stranger Things: The Early Gothic",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4X03",
    name: "Honours Essay",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4Y03",
    name: "Experiential Practicum I",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4Y06",
    name: "Research Practicum",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGLISH",
    code: "4YY3",
    name: "Experiential Practicum II",
    classification: "English",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGNMGT",
    code: "2AA3",
    name: "Communication Skills",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGNMGT",
    code: "4A03",
    name: "Innovation Driven Project Development and Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGNMGT",
    code: "5B03",
    name: "Engineering & Management Capstone",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "2A04",
    name: "Electricity and Magnetism",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "2CD4",
    name: "Computational Mechanics: Dynamics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "2CM4",
    name: "Computational Multiphysics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "2E04",
    name: "Analog and Digital Circuits",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "2NE3",
    name: "Thermal Systems Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "2P04",
    name: "Computational Mechanics: Statics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "2QM3",
    name: "Introduction to Quantum Mechanics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "3BA3",
    name: "Circuits with Non-Linear and Active Components",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "3BB3",
    name: "Embedding and Programming a Micro-Controller",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "3D04",
    name: "Principles of Nuclear Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "3E04",
    name: "Fundamentals of Physical Optics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "3ES3",
    name: "Introduction to Energy Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "3H04",
    name: "Research Project in Engineering Physics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "3L04",
    name: "Engineering Metrology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "3NM4",
    name: "Numerical Methods for Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "3O04",
    name: "Introduction to Fluid Mechanics and Heat Transfer",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "3PD4",
    name: "Photonic Devices",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "3PN4",
    name: "Semiconductor Junction Devices",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "3SM3",
    name: "Statistical Mechanics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "3SP3",
    name: "Space Systems Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "3W03",
    name: "Signals and Systems for Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4A06",
    name: "Engineering Physics Design and Synthesis Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4B03",
    name: "Biosensors",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4D04",
    name: "Nuclear Reactor Physics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4H04",
    name: "Research Project in Engineering Physics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4I03",
    name: "Introduction to Biophotonics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4MD3",
    name: "Nanoscale Semiconductor Devices",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4NE3",
    name: "Advanced Nuclear Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4P03",
    name: "Nuclear Power Plant Systems and Operation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4PP3",
    name: "Plasma Physics Applications",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4QC3",
    name: "Introduction to Quantum Computing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4QM3",
    name: "Quantum Optics and Metrology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4S04",
    name: "Lasers and Electro-Optics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4US2",
    name: "Smart Systems Design & Implementation Laboratory",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4X03",
    name: "Introduction to Photovoltaics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGPHYS",
    code: "4Z04",
    name: "Semiconductor Manufacturing Technology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGSOCTY",
    code: "2X03",
    name: "Inquiry in an Engineering Context I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGSOCTY",
    code: "2Y03",
    name: "Case Studies in History and Technology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGSOCTY",
    code: "3X03",
    name: "Inquiry in an Engineering Context II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGSOCTY",
    code: "3Y03",
    name: "Technology and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGSOCTY",
    code: "3Z03",
    name: "Preventive Engineering: Environmental Perspectives",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGSOCTY",
    code: "4X03",
    name: "Inquiry in an Engineering Context III",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGSOCTY",
    code: "4Y03",
    name: "Society Capstone Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "1AC3",
    name: "Analytical Chemistry",
    classification: "Inorganic/Introductory Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "1BI3",
    name: "Biology",
    classification: "Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "1CH3",
    name: "Chemistry",
    classification: "Inorganic/Introductory Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "1CP3",
    name: "C++ Programming",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "1EL3",
    name: "Electricity and Electronics I",
    classification: "Physics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "1ET0",
    name: "Introduction to the Technology Co-op Program",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "1MC3",
    name: "Mathematics I",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "1ME3",
    name: "Statics and Mechanics of Materials",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "1MT3",
    name: "Mathematics II",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "1PH3",
    name: "Physics",
    classification: "Physics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "1PP3",
    name: "Python Programming",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "1PR3",
    name: "Object-Oriented Programming",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "2EE0",
    name: "Four Month Co-op Experience I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "2ES3",
    name: "Engineering Statistics",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "2ET0",
    name: "Four Month Co-op Experience I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "2MA3",
    name: "Mathematics III",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "2MS3",
    name: "Modelling and Numerical Solutions",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "2MT3",
    name: "Mathematics IV",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "3DM3",
    name: "Discrete Mathematics",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "3EE0",
    name: "Four Month Co-op Experience II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "3ES3",
    name: "Engineering Statistics",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "3ET0",
    name: "Four Month Co-op Experience II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "3FE3",
    name: "Finite Element Analysis",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "3MA3",
    name: "Mathematics V",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "3ML3",
    name: "Strength of Materials",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "3MN3",
    name: "Modelling and Numerical Solutions",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "3SD3",
    name: "Statics and Dynamics",
    classification: "Physics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "3SP3",
    name: "Structure and Properties of Materials",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "3ST3",
    name: "Probability and Statistics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "3TD3",
    name: "Thermodynamics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "4AI3",
    name: "Artificial Intelligence",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "4CT3",
    name: "Systems and Control",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "4ED3",
    name: "Senior Engineering Design Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "4EE0",
    name: "Four Month Co-op Experience III",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "4EP3",
    name: "Senior Engineering Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "4EX0",
    name: "Four Month Co-op Experience",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "4FA3",
    name: "Finite Element Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "4FD3",
    name: "Senior Engineering Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "4MA3",
    name: "Advanced Mathematics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENGTECH",
    code: "4TF3",
    name: "Mechanics of Fluids",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENRTECH",
    code: "3EP3",
    name: "Power Systems and Electrical Machines",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENRTECH",
    code: "3IE3",
    name: "Industrial Electronics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENRTECH",
    code: "3IN3",
    name: "Industrial Networks and Communication Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENRTECH",
    code: "3MI3",
    name: "Measurements and Instrumentation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENRTECH",
    code: "3PD3",
    name: "Power Distribution I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENRTECH",
    code: "4CA3",
    name: "Computer Applications in Power System Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENRTECH",
    code: "4EM3",
    name: "Transmission Lines and Electromagnetics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENRTECH",
    code: "4PD3",
    name: "Power System Analysis and Control",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENRTECH",
    code: "4PM3",
    name: "Power Protection and Maintenance I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENRTECH",
    code: "4PP3",
    name: "Power Protection and Maintenance II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENRTECH",
    code: "4PQ3",
    name: "Power Quality",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENRTECH",
    code: "4RG3",
    name: "Renewable Generation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "1C03",
    name: "Climate, Water and Environment",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "2B03",
    name: "Soils and the Environment",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "2C03",
    name: "Surface Climate Processes and Environmental Interactions",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "2Q03",
    name: "Introduction to Environmental Geochemistry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "2W03",
    name: "Physical Hydrology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "2WW3",
    name: "Water and the Environment",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "3B03",
    name: "Ecosystems and Global Change",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "3IN3",
    name: "Internship in Earth and Environmental Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "3ME3",
    name: "Environmental Field Camp",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "3O03",
    name: "Contaminant Fate and Transport",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "4BB3",
    name: "Field Techniques in Hydrology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "4C03",
    name: "Advanced Physical Climatology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "4EA3",
    name: "Environmental Assessment",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "4MI3",
    name: "Independent Study in Earth and Environmental Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "4MT6",
    name: "Senior Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "4N03",
    name: "Global Biogeochemical Cycles",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVIRSC",
    code: "4W03",
    name: "Hydrologic Modelling",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "1HA3",
    name: "Society, Culture and Environment",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "1HB3",
    name: "Population, Cities and Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "2EI3",
    name: "Environment & Society: Challenges and Solutions",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "2EK3",
    name: "Traditional Indigenous Ecological Knowledge",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "2GI3",
    name: "Geographic Information Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "2HI3",
    name: "Health and Place",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "2LE3",
    name: "Economic Geography: Innovation, Inequality and Identity",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "2OC3",
    name: "Regional Geography of Canada",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "2RC3",
    name: "Regional Geography of Canada",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "2RU3",
    name: "Regional Geography of the United States",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "2RW3",
    name: "World Regional Geography",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "2TF3",
    name: "Food, Power and Place",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "2TS3",
    name: "Society and Space",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "2UI3",
    name: "The Urban Experience",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3EC3",
    name: "Environmental Catastrophes",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3EE3",
    name: "Energy and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3EG3",
    name: "Politics of a Dying Planet",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3EN3",
    name: "Northern Environments and Societies",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3ER3",
    name: "Sustainability and the Economy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3GI3",
    name: "Advanced Raster GIS",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3GV3",
    name: "Advanced Vector GIS",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3HP3",
    name: "Population, Health and Aging",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3LT3",
    name: "Transportation Geography",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3MA3",
    name: "Research Methods",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3MB3",
    name: "Data Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3MF3",
    name: "Urban Field Camp",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3MI3",
    name: "Internship in Environment and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3RA3",
    name: "Africa’s Human Geographies",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3RW3",
    name: "Regional Geography of a Selected World Region",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3SR3",
    name: "Remote Sensing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3TG3",
    name: "Geographies of Globalization",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3UP3",
    name: "Urban Planning",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3UR3",
    name: "Urban Social Geography",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "3UW3",
    name: "Cities of the Developing World",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4EA3",
    name: "Environmental Assessment",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4ET3",
    name: "Environmental Policy, Ethics and Risk",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4GA3",
    name: "Applied Spatial Statistics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4GS3",
    name: "GIS Programming",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4GT3",
    name: "Special Topics in GIS",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4HC3",
    name: "Public and Community Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4HD3",
    name: "Disability, Society and Environment",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4HH3",
    name: "Environment and Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4LE3",
    name: "Geographies of the North American Political Economy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4LP3",
    name: "Transport Policy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4LW3",
    name: "Work and the Environment",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4MF3",
    name: "Senior Urban Field Camp",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4MS3",
    name: "Independent Study",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4MT6",
    name: "Senior Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4SR3",
    name: "Advanced Remote Sensing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4UD3",
    name: "Special Topics in Urban Planning",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4UF3",
    name: "The Geography of Gender",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ENVSOCTY",
    code: "4US3",
    name: "Sustainable Cities",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EPHYSBME",
    code: "5P06",
    name: "Integrated Engineering Physics & Biomedical Engineering Capstone Design Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EXPLORE",
    code: "3IE3",
    name: "Interdisciplinary Experiences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EXPLORE",
    code: "3IS0",
    name: "Interdisciplinary Science Field Work",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "EXPLORE",
    code: "3IS3",
    name: "Interdisciplinary Science Field Camp",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FARSI",
    code: "1Z03",
    name: "Introductory Farsi I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FARSI",
    code: "1ZZ3",
    name: "Introductory Farsi II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "1A06",
    name: "Introduction to French Studies: Advanced Level",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "1Z06",
    name: "Beginner’s Intensive French I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "2AC3",
    name: "Introduction to Francophone Literatures and Cultures",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "2B03",
    name: "French Language Practice I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "2BB3",
    name: "French Language Practice II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "2CC3",
    name: "Women’s Writing",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "2E03",
    name: "Survey of Quebec Literature and Culture",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "2F03",
    name: "Survey of French and Francophone Literature",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "2G03",
    name: "Elementary Translation from English to French",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "2I03",
    name: "Professional French I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "2JJ3",
    name: "Nineteenth-Century French Literature",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "2L03",
    name: "Introduction to Literary Analysis",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "2M06",
    name: "Introduction to French Studies: Advanced Level",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "2Z06",
    name: "Beginner’s Intensive French II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "3AA3",
    name: "The Modern French-Canadian Novel",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "3AC3",
    name: "Francophone Writers",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "3C03",
    name: "French Language Practice III",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "3CC3",
    name: "Intermediate Translation from English to French",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "3EE3",
    name: "Recent French Literature",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "3FF3",
    name: "Francophone Cinemas",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "3GG3",
    name: "Elementary Translation from French to English",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "3HH3",
    name: "Francophone Voices in Canada",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "3II3",
    name: "Professional French II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "3KK3",
    name: "Revolutionary Literature Before the Revolution: Voltaire, Rousseau and Beaumarchais",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "3P03",
    name: "History and Philosophy of Education",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "3Q03",
    name: "Seventeenth-Century French Literature",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "3W03",
    name: "Twentieth-Century French Literature",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "4A03",
    name: "French Language Practice IV",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "4CC3",
    name: "Theoretical Reflections on Interdisciplinarity",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "4DD3",
    name: "Animals in French and Francophone Literatures",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "4I03",
    name: "French Poetry from the Renaissance to the Present",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "4LL3",
    name: "Topics in Francophone Literatures",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "4MM3",
    name: "Sex, Violence and Elegance: The 18th-Century Novel",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "4P06",
    name: "French as a Second Language: From Theory to Practice",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "4T03",
    name: "Independent Study",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "4U03",
    name: "Topics in Literature and Culture of Quebec and Francophone Canada",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "FRENCH",
    code: "4Y03",
    name: "Topics in 20th-Century French Literature",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENDRST",
    code: "1A03",
    name: "Gender, Race, Culture, Power",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENDRST",
    code: "1AA3",
    name: "Gender, Feminism and Social Justice",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENDRST",
    code: "2AA3",
    name: "Feminist Thought",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENDRST",
    code: "2BB3",
    name: "Images of the Divine Feminine",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENDRST",
    code: "3BB3",
    name: "Gender and Visual Culture",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENDRST",
    code: "3BW3",
    name: "Gender in Ancient Eastern Mediterranean",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENDRST",
    code: "3FF3",
    name: "Gender and Religion",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENDRST",
    code: "3RR3",
    name: "Cripping Performance: Deaf, Mad and Disabled Performance in Canada",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "1BZ3",
    name: "Foundations of Business",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "1PC3",
    name: "Professional Communications",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "2EE3",
    name: "Engineering Economics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "2HR3",
    name: "Human Resource Fundamentals",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "2MP3",
    name: "Management Principles",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "3DM3",
    name: "Creativity, Innovation and Technology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "3EE3",
    name: "Engineering Economics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "3FF3",
    name: "Financial Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "3FS3",
    name: "Financial Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "3LS3",
    name: "Quality Control and Assurance Methods",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "3MB3",
    name: "Fundamentals of Marketing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "3MP3",
    name: "Management Principles",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "3MT3",
    name: "Project Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "4EM3",
    name: "Legal and Regulatory Issues",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "4EN3",
    name: "Entrepreneurial Thinking and Innovation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "4EP3",
    name: "Entrepreneurial Thinking and Innovation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "4FT3",
    name: "Strategic Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "4LM3",
    name: "Lean Thinking and Practices",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "4MK3",
    name: "Fundamentals of Marketing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "4OM3",
    name: "Operations Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "4PM3",
    name: "Project Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "4SE3",
    name: "Technology Ethics and Sustainability",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "4SF3",
    name: "Strategic Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "4ST3",
    name: "Contemporary Issues in Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "4TC3",
    name: "Technical Communications",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GENTECH",
    code: "4TE3",
    name: "Technology Ethics and Sustainability",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "1B03",
    name: "Intermediate German I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "1BB3",
    name: "Intermediate German II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "1Z06",
    name: "Beginner’s Intensive German",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "2CC3",
    name: "Germany Through the Ages: Culture and Society (Taught in English)",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "2FT3",
    name: "The Fairy Tale (Taught in English)",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "2G03",
    name: "Berlin/Vienna: The Cultural Life of these Cities (Taught in English)",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "2KK3",
    name: "Postmodern Alienation and Anxieties",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "2N03",
    name: "The Holocaust in Film and Fiction (Taught in English)",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "2P03",
    name: "Modern Germany Through Film: Golden 20s",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "2Q03",
    name: "Horror Film: Vampires, Monsters, and Mad Scientists (Taught in English)",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "2Z03",
    name: "Intermediate German I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "2ZZ3",
    name: "Intermediate German II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "3H03",
    name: "The New Europe: A New Germany (Taught in English)",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "3Z03",
    name: "Advanced German I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "3ZZ3",
    name: "Advanced German II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "4CC3",
    name: "Translation: Techniques and Practice",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GERMAN",
    code: "4II3",
    name: "Independent Study",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "1A03",
    classification: "Humanities",
    name: "Introduction to Greek and Roman Archaeology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "1B03",
    classification: "Humanities",
    name: "An Introduction to Ancient Myth and Literature",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "1M03",
    classification: "Humanities",
    name: "History of Greece and Rome",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "2B03",
    classification: "Humanities",
    name: "Greek Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "2BB3",
    classification: "Humanities",
    name: "Constructing the Ancient World",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "2C03",
    classification: "Humanities",
    name: "Roman Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "2CC3",
    classification: "Humanities",
    name: "Archaeology of the Roman Empire",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "2D03",
    classification: "Humanities",
    name: "Greek and Roman Mythology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "2E03",
    classification: "Humanities",
    name: "The Ancient World in Film",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "2HA3",
    classification: "Humanities",
    name: "Athens and Sparta: Democracy, Oligarchy, and War",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "2HB3",
    classification: "Humanities",
    name: "From Alexander to Cleopatra: Cosmopolis and Empire",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "2HC3",
    classification: "Humanities",
    name: "Caesar and the Rise of Autocracy",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "2HD3",
    classification: "Humanities",
    name: "Nero, Decadence, and the End of a Dynasty",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "2K03",
    classification: "Humanities",
    name: "The Society of Greece and Rome",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "2LW3",
    classification: "Humanities",
    name: "Ancient Law",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "2MT3",
    classification: "Humanities",
    name: "Ancient Roots of Medical Terminology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "2YY3",
    classification: "Humanities",
    name: "Greek Tragedy",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "3EE3",
    classification: "Humanities",
    name: "The Greek Historians",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "3ER3",
    classification: "Humanities",
    name: "Epics of Rome",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "3HH3",
    classification: "Humanities",
    name: "Roman Slavery",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "3M03",
    classification: "Humanities",
    name: "Greek Intellectual Revolution",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "3MT3",
    classification: "Humanities",
    name: "Advanced Ancient Roots of Medical Terminology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "3N03",
    classification: "Humanities",
    name: "Connectivity in the Ancient Mediterranean",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "3Q03",
    classification: "Humanities",
    name: "Greek Sanctuaries",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "3S03",
    classification: "Humanities",
    name: "Pompeii, Herculaneum, and Ostia",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "3X03",
    classification: "Humanities",
    name: "Roman Religion",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "3YY3",
    classification: "Humanities",
    name: "Ovid",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "4E03",
    classification: "Humanities",
    name: "Seminar in Ancient Culture",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "4F03",
    classification: "Humanities",
    name: "Seminar in Ancient History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "4FP3",
    classification: "Humanities",
    name: "Field Practicum in Greek and Roman Archaeology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "4H03",
    classification: "Humanities",
    name: "Death and Commemoration in the Roman World",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "4L03",
    classification: "Humanities",
    name: "Athenian Democracy",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "4MR3",
    classification: "Humanities",
    name: "The Myth and Reality of Troy",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "4T03",
    classification: "Humanities",
    name: "Independent Study",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GKROMST",
    code: "4U03",
    classification: "Humanities",
    name: "The Severe Style in Greek Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GLOBALZN",
    code: "1A03",
    name: "Global Citizenship",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GLOBALZN",
    code: "3A03",
    name: "Globalization, Social Justice, and Human Rights",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GREEK",
    code: "1Z03",
    name: "Beginner’s Intensive Ancient Greek I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GREEK",
    code: "1ZZ3",
    name: "Beginner’s Intensive Ancient Greek II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GREEK",
    code: "2A03",
    name: "Intermediate Greek I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GREEK",
    code: "2AA3",
    name: "Intermediate Greek II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GREEK",
    code: "3AA3",
    name: "Greek Prose",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GREEK",
    code: "3BB3",
    name: "Topics in Greek Literature",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GREEK",
    code: "3E03",
    name: "Topics in Greek Poetry",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "GREEK",
    code: "4T03",
    name: "Independent Study in Greek",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HEBREW",
    code: "2A03",
    name: "Introduction to Biblical Hebrew I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HEBREW",
    code: "2B03",
    name: "Introduction to Biblical Hebrew II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HEBREW",
    code: "3A03",
    name: "Intermediate Hebrew I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HEBREW",
    code: "3B03",
    name: "Intermediate Hebrew II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "1CC3",
    name: "Ten Empires that Shaped our World, 500 BCE to Present",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "1DD3",
    name: "The Making of the Modern World, 1750-1945",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "1EE3",
    name: "The Historical Roots of Contemporary Issues",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "1FF3",
    name: "Exploring History in a Small Group Setting",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "1M03",
    name: "History of Greece and Rome",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "1P03",
    name: "A History of Magic",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "1PP3",
    name: "Pop Goes the Past!",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "1Q03",
    name: "History of Medicine",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2A03",
    name: "Modern Middle Eastern Societies",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2CC3",
    name: "The Medieval World 400-1050",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2CH3",
    name: "Introduction to Critical Heritage Studies",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2CS3",
    name: "The History of Slavery in the Americas",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2DD3",
    name: "The Medieval World 1050-1400",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2DF3",
    name: "Art and Revolutions in France, 1789-1914",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2EN3",
    name: "The Post-Slavery Caribbean",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2G03",
    name: "Modern Latin America Since 1820",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2GR3",
    name: "A History of Monsters",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2GW3",
    name: "A History of Global War",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2H03",
    name: "Tudor and Stuart Britain, 1485-1714",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2HH3",
    name: "Pirates, Pilgrims and the Enslaved in the Mediterranean, 1450-1750",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2II3",
    name: "Modern Germany",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2IS3",
    name: "Historical Roots of Current Social and Political Crises in the United States",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2J03",
    name: "Africa up to 1800",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2JJ3",
    name: "Africa since 1800",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2KK3",
    name: "History of Capitalism",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2MC3",
    name: "Modern China",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2PP3",
    name: "Making History",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2PQ3",
    name: "Histories of the Written Word",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2Q03",
    name: "Imperial Russia",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2QQ3",
    name: "The Soviet Union",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2R03",
    name: "U.S. History to the Civil War",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2RR3",
    name: "U.S. History Since the Civil War",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2SH3",
    name: "Canadian Sport History",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2SS3",
    name: "Liberty, Empire and Industry: Britain, 1688-1867",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2ST3",
    name: "Empire, War, Welfare State: Britain, 1867-2020",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2T03",
    name: "Survey of Canadian History, Beginnings to 1885",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2TT3",
    name: "Survey of Canadian History, 1885 to the Present",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2UV3",
    name: "American Foreign Relations since 1898",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2V03",
    name: "Re-Making History",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "2XX3",
    name: "Age of Terror: History of Terrorism in the Modern World",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3AR3",
    name: "Atlantic Revolutions, 1750-1804",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3CG3",
    name: "Canadians in a Global Age, 1914 to the Present",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3CH3",
    name: "Catastrophic History: Natural & Technological Disasters",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3DD3",
    name: "Jews and Jesus",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3DF3",
    name: "Art and Politics in Second Empire France",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3DS3",
    name: "Diasporas, Trade and Conflict: The Sea in History, 1000 BCE to Present",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3EC3",
    name: "Chinese Intellectual Traditions",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3FF3",
    name: "Nazi Germany",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3GN3",
    name: "Moments in Twentieth Century History Through the Graphic Novel",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3H03",
    name: "Italian Renaissance, 1300-1600",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3HI3",
    name: "Advanced Historical Inquiry",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3HQ3",
    name: "History of Quebec",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3I03",
    name: "The International Relations of the European Powers, 1870-1945",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3J03",
    name: "The United States in the 1960s",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3JJ3",
    name: "Crime, Constables, and Courts: Modern Criminal Justice, 1700 to Present",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3JR3",
    name: "Justice and Reparations in the Post-slavery World",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3KK3",
    name: "The Vietnam War",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3N03",
    name: "Poverty, Privilege and Protest in Canadian History",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3RU3",
    name: "Early Modern Russia",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3ST3",
    name: "Street Life in Canada",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3TC3",
    name: "Science, Technology in World History",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3TR3",
    name: "Trees and their Histories",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3UA3",
    name: "The History of the Future",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3W03",
    name: "Women in Canada and the U.S. to 1920",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3WW3",
    name: "Women in Canada and the U.S. from 1920",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3XX3",
    name: "Human Rights in History",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3YB3",
    name: "Youth Subcultures in Britain: From the Teds to the Acid Ravers",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3YY3",
    name: "Britain and the First World War",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "3ZZ3",
    name: "Judaism in the Modern World",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4AW3",
    name: "North Atlantic Crossings, 1750-1940",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4CE3",
    name: "Early Canadian History",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4CM3",
    name: "Modern Canadian History",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4DW3",
    name: "Indigenous History in a Decolonizing World",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4E03",
    name: "Medieval People",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4FF3",
    name: "History of Health and Medicine in the Colonial World",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4G03",
    name: "Nation and Genocide in the Modern World",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4HH3",
    name: "China’s Great Cultural Revolution",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4HP3",
    name: "The History Practicum",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4I03",
    name: "Women and Social Movements in the 19th- and 20th- Century United States",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4JJ3",
    name: "U.S. Foreign Relations",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4K03",
    name: "Environment and Environmentalism in Modern North America",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4KK3",
    name: "Research on the British Atlantic, 1750-1850",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4LP3",
    name: "The Cultural History of Paris, 1789-1914",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4MM3",
    name: "White Supremacists and Human Rights Activists in Modern Canadian History",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4P03",
    name: "Contemporary Europe",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4PP3",
    name: "Divided Germany",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4QQ3",
    name: "The Soviet Experience",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4QR3",
    name: "Quantitative Research on Major Topics in History",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4RP3",
    name: "Independent Research Project",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4RP6",
    name: "Advanced Independent Research",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4RR3",
    name: "Truth and Reconciliation After Atrocity",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4S03",
    name: "The German Reformation",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4SS3",
    name: "Early Modern France, 1450-1789",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HISTORY",
    code: "4TT3",
    name: "Interwar Europe, 1918-1939",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "1AA3",
    name: "Introduction to Health and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "1BB3",
    name: "Introduction to Aging and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "1CC3",
    name: "Introduction to Mental Health and Illness",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "1ZZ3",
    name: "Inquiry: Introduction to Health and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "2A03",
    name: "Research Methods in Health and in Aging I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "2AN3",
    name: "The Anthropology of Food and Nutrition",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "2B03",
    name: "Social Identity, Health and Illness",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "2BB3",
    name: "Perspectives in Health, Aging and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "2C03",
    name: "Health Economics and its Application to Health Policy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "2D03",
    name: "Continuum of Care",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "2F03",
    name: "Aging and Health Care Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "2GG3",
    name: "Mental Health and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "2HI3",
    name: "Health & Place",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "2J03",
    name: "Selected Topics in Aging and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "2K03",
    name: "Selected Topics in Health and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "2L03",
    name: "Drugs, Sex and Alcohol: Society and its Addictions",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "2M03",
    name: "Aging in Modern (and Post-Modern) Families",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "2N03",
    name: "Treatment Within the World of Mental Illness: Desperation and Debate",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3AA3",
    name: "State, Civil Society and Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3AB3",
    name: "Kindred Species: Animals, Health and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3B03",
    name: "Advanced Research Methods",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3BB3",
    name: "Field Experience",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3D03",
    name: "Perspectives on Disability, Chronic Illness and Aging",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3DD3",
    name: "Work: Dangerous to your Health?",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3E03",
    name: "Ethical Issues in Health and Aging",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3EE3",
    name: "The Practice of Everyday Life: Observations and Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3G03",
    name: "Community Based Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3HP3",
    name: "Population, Health and Aging",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3I03",
    name: "Independent Study in Health, Aging and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3K03",
    name: "Social Determinants of Population Health in Canada",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3L03",
    name: "Embodied Aging",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3M03",
    name: "Approaches to Mental Health and Resilience",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3N03",
    name: "Aging and Mental Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3Q03",
    name: "Selected Topics in Health and Aging",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3R03",
    name: "Health Inequalities",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3S03",
    name: "Global Health and Environment Policy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3T03",
    name: "Health and Incarceration",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "3YY3",
    name: "Indigenous Community Health and Wellbeing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4AB3",
    name: "Living Well with Dementia: Social and Physical Environments",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4B03",
    name: "Death and Dying in Later Life",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4BC3",
    name: "Civic Engagement and Applied Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4C03",
    name: "Representations of Health and Illness Across the Lifecourse",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4D03",
    name: "Health, Culture and Diversity",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4F03",
    name: "Selected Issues in Health and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4G03",
    name: "Global Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4H03",
    name: "History and Culture of Aging",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4I03",
    name: "Aging and Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4J03",
    name: "Narratives of Illness",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4L03",
    name: "Social Policy and Aging",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4M03",
    name: "Environment and Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4N03",
    name: "Aging and Wellbeing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4O03",
    name: "Soundscapes of Wellbeing in Popular Music",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4P03",
    name: "Leisure and Recreation in Later Life",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4Q03",
    name: "Representations of Mental Illness",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4R03",
    name: "Beyond the Social: Determinants of Indigenous Peoples Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4S03",
    name: "Health and the Unfairly Structured City",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4T03",
    name: "Gender, Sex and Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4U03",
    name: "Professions and Occupations in Health and Aging",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4W03",
    name: "Selected Issues in Aging and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HLTHAGE",
    code: "4Z06",
    name: "Health, Aging and Society Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1A00",
    name: "Competencies in Animal Care and Research: Orientation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1B00",
    name: "Competencies in Animal Care and Research: Methodologies",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1C00",
    name: "Competencies in Animal Care and Research: Completion of Ethical Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1DT3",
    name: "Discover Immunology Today",
    classification: "Immunology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1E06",
    name: "Inquiry I: Introduction",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1G02",
    name: "Interdisciplinary Question in Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1I06",
    name: "Cellular and Molecular Biology",
    classification: "Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1M03",
    name: "Foundations of Data Science",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1X01",
    name: "Praxis Pathways 1",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2AE3",
    name: "Artistic Explorations of Community Issues",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2CH3",
    name: "CHS Learning Modules",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2CH6",
    name: "CHS Inquiry Fundamentals",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2D06",
    name: "Inquiry II: Introduction and Biochemistry",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2DS3",
    name: "Global Health and the Complexities of Disease",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2E03",
    name: "Inquiry II: Biochemistry",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2F03",
    name: "Human Physiology and Anatomy I",
    classification: "Anatomy",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2FF3",
    name: "Human Physiology and Anatomy II",
    classification: "Anatomy",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2G03",
    name: "Statistics & Epidemiology 1",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2GG3",
    name: "Statistics & Epidemiology 2",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2K03",
    name: "Inquiry II: Cell Biology",
    classification: "Cell Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2L03",
    name: "Anatomy and Physiology I: Communication",
    classification: "Anatomy",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2LL3",
    name: "Anatomy and Physiology II: Homeostasis",
    classification: "Anatomy",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2ML3",
    name: "Introduction to Medical Laboratory Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2T03",
    name: "Sex, Gender, & Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2X03",
    name: "Praxis Pathways 2",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3AH3",
    name: "Indigenous Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3BA3",
    name: "Symptomatology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3CC3",
    name: "Theatre for Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3CH3",
    name: "CHS Inquiry Intermediate",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3CH6",
    name: "CHS Research Practicum",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3CH9",
    name: "CHS Inquiry Intermediate",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3DD6",
    name: "Engaging the City: An Introduction to Community-Based Research in Hamilton",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3DH3",
    name: "Discourses of Health & Illness",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3DM3",
    name: "Demystifying Medicine",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3DR3",
    name: "Demystifying Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3E03",
    name: "Inquiry III: Advanced Inquiry in Health Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3EE3",
    name: "Biomedical Graphics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3FC3",
    name: "Science of Fictional Characters",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3G03",
    name: "Critical Appraisal of the Health Literature",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3GG3",
    name: "Health Systems and Health Policy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3H03",
    name: "Inquiry Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3H06",
    name: "Inquiry Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3HH3",
    name: "Deceptions in Decision Making",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3HL3",
    name: "Health Law: Current and Emerging Issues",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3HR3",
    name: "Research Skills",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3I03",
    name: "Introductory Immunology",
    classification: "Immunology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3JJ3",
    name: "The Science of Feeling Good",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3K03",
    name: "Principles of Virology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3KK3",
    name: "Seeing and Understanding Data",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3L03",
    name: "Introduction to Bioethics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3MH3",
    name: "Critical Examination of Mental Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3MR6",
    name: "Practicum in Medical Research.",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3MU3",
    name: "Music, Health, & the Community",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3N03",
    name: "Creative Writing in the Health Sciences",
    classification: "Writing",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3NN3",
    name: "Inquiry in Perinatal & Reproductive Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3PH3",
    name: "The Politics of Help",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3PP3",
    name: "Health Ventures",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3QA3",
    name: "Qualitative Research Methods in Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3RH3",
    name: "Racism and Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3RS3",
    name: "Exploring the Foundations of Rehabilitation Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3S03",
    name: "Communication Skills",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3SB3",
    name: "Superbugs: Bacterial Antibiotic Resistance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3SS3",
    name: "Surviving Survivor: Insights from Reality TV for Real Life",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3T03",
    name: "Inquiry into Work, Self and Purpose",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3U03",
    name: "Medical Genetics",
    classification: "Genetics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3V03",
    name: "Research and Experimental Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3WT3",
    name: "What Trauma Teaches: Lessons from Listening",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3X00",
    name: "Praxis Pathways 3",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3X03",
    name: "Pain: Perceptions, Mechanisms and Intervention",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4A09",
    name: "Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4A12",
    name: "Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4A15",
    name: "Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4AA3",
    name: "Group Dynamics and Processes",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4AC3",
    name: "Advanced Communication Skills",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4AL3",
    name: "Model Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4B06",
    name: "Senior Projects",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4BB3",
    name: "Neuroimmunology",
    classification: "Immunology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4BL3",
    name: "Peer Tutoring in Design Thinking",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4BR6",
    name: "Research Skills and Application",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4C06",
    name: "Senior Project in Child Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4C09",
    name: "Thesis in Child Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4C12",
    name: "Thesis in Child Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4C15",
    name: "Thesis in Child Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4CH3",
    name: "CHS Education Practicum",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4CH6",
    name: "CHS Inquiry Advanced",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4CU3",
    name: "Cultural Competency in Health Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4D03",
    name: "Special Topics in Health Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4D06",
    name: "Senior Project in Engaging the City",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4D09",
    name: "Thesis in Engaging the City",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4D12",
    name: "Thesis in Engaging the City",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4D15",
    name: "Thesis in Engaging the City",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4DE3",
    name: "Senior Project in Engaging the City",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4DN3",
    name: "Dance in Health and Wellness",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4EE3",
    name: "Education Practicum in Health Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4FF3",
    name: "Integrative Leadership Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4G03",
    name: "Pathoanatomy",
    classification: "Anatomy",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4G06",
    name: "Senior Project in Global Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4G09",
    name: "Thesis in Global Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4G12",
    name: "Thesis in Global Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4G15",
    name: "Thesis in Global Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1C06",
    name: "Social Justice and Healthcare",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1CC6",
    name: "Integrated Biological Bases of Nursing Practice I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1D06",
    name: "Anatomy and Physiology",
    classification: "Anatomy",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1H06",
    name: "Human Anatomy and Physiology I",
    classification: "Anatomy",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1J03",
    name: "Life Sciences for Clinical Practice",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1LL3",
    name: "Human Biochemistry I",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "1RR3",
    name: "Introduction to the Social Determinants of Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2C06",
    name: "Integrated Biological Bases of Nursing Practice II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2H03",
    name: "Introductory Pharmacology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2HH3",
    name: "Introductory Microbiology",
    classification: "Microbiology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2LA2",
    name: "Introduction to Integrated Pathophysiology for Nursing for Basic Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2M03",
    name: "Reproductive Physiology",
    classification: "Anatomy",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2PF3",
    name: "Introduction to Integrated Pathophysiology for Accelerated Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "2S03",
    name: "Introduction to Statistics for Nursing",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3BB3",
    name: "Human Biochemistry II: Nutrition and Metabolism",
    classification: "Biochemistry",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3BE4",
    name: "Nursing Concepts in Continence Care",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3BF3",
    name: "Nursing Concepts in Continence Care Placement",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3BG3",
    name: "Advanced Nursing Concepts in Continence Care",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3C04",
    name: "Research Appraisal and Utilization in Evidence Informed Decision Making",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3PA2",
    name: "Integrated Pathophysiology for Nursing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "3PF1",
    name: "Integrated Pathophysiology for Accelerated Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4AR3",
    name: "Nursing Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4BR3",
    name: "Independent Study",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4NR3",
    name: "Nursing Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4IC3",
    name: "Integration of Children’s Physical and Mental Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4ID3",
    name: "Innovation By Design I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4IH3",
    name: "Indigenous Health Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4II3",
    name: "Advanced Concepts in Immunology",
    classification: "Immunology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4IS3",
    name: "Frameshift Innovation Labs",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4J03",
    name: "Immunological Principles In Practice",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4JJ3",
    name: "Building Undergraduate Research Capacity",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4K03",
    name: "Human Pathophysiology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4KK3",
    name: "Pathophysiology of Infectious Diseases",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4KT3",
    name: "Demystifying Science",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4LA3",
    name: "Innovation By Design II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4LB3",
    name: "Leadership and Management 1",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4LC3",
    name: "Leadership and Management 2",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4LD3",
    name: "Global Health Governance, Law and Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4LL3",
    name: "Integrated Health Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4M03",
    name: "Advanced Concepts in Health Psychology",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4MS3",
    name: "The Social Lives of Molecules",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4NC3",
    name: "Navigating Complexity in Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4NN3",
    name: "Creative Writing in Health Sciences II",
    classification: "Writing",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4NU3",
    name: "Nutrition",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4O03",
    name: "Principles of Virus Pathogenesis",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4PA3",
    name: "Global Health Innovation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4QQ3",
    name: "Communication Skills Practicum",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4SC3",
    name: "Social Determinants of Child Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4SR3",
    name: "Global Sexual and Reproductive Health and Rights",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4SS6",
    name: "Group Process Practicum",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4TE3",
    name: "The Teaching Hospital",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4TT3",
    name: "Research Practicum",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4W03",
    name: "Special Topics in Health Sciences II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4WW3",
    name: "Education Practicum",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4XP3",
    name: "Praxis Pathways 4",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4XX3",
    name: "Professional Transitions",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4Y03",
    name: "Science, Culture and Identity",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HTHSCI",
    code: "4ZZ3",
    name: "Global Health Advocacy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "1VV3",
    name: "Voice and Vision: Words to Change the World",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "2CP2",
    name: "Humanities Career Planning and Development",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "2DH3",
    name: "Creative, Collaborative, Critical: Approaches to Digital Scholarship",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "3CL3",
    name: "Community Leadership at McMaster",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "3CM3",
    name: "Leadership: Cross-Cultural Mentoring Lab",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "3IF0",
    name: "Full-time Internship",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "3IF1",
    name: "Full-time Internship",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "3IP0",
    name: "Part-time Internship",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "3IP1",
    name: "Part-time Internship",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "3LM3",
    name: "Foundations of Ethical Leadership",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "3W03A",
    name: "Applied Humanities I",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "4CM3",
    name: "Cross-cultural Mentoring and Coaching Practicum",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "4LC3",
    name: "Major Leadership Project: Theory and Practice",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "4RM3",
    name: "Boundaries and Bridges: Relationship Skills for Effective Leaders",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "4SI3",
    name: "Innovation for Social Impact",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "4W03",
    name: "Applied Humanities II",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMAN",
    code: "4WL3",
    name: "Wilson Leadership Scholar Capstone",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "2A06",
    name: "Introduction to Autism Spectrum Disorder (ASD)",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "2AP3",
    name: "Introduction to Applied Psychology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "2B06",
    name: "Introduction to Applied Behaviour Analysis (ABA) I",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "2C03",
    name: "Specialized Instructional Strategies (SIS) I",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "2FP6",
    name: "Field Placement I",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "2FS3",
    name: "Field Placement I Seminar",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "2L03",
    name: "Philosophy and Curriculum Design",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "2M03",
    name: "Learning Environment I",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "2TL3",
    name: "Responsive Care for Infants and Toddlers",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "2XP6",
    name: "ECS Practicum I",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3AP3",
    name: "Advanced Applied Psychology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3CB3",
    name: "Treating Challenging Behaviour I",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3D03",
    name: "Applied Behavioural Analysis (ABA) II",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3E06",
    name: "Behavioural Skill Building",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3F03",
    name: "Ethics and Professionalism",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3FP9",
    name: "Field Placement II",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3FS3",
    name: "Field Placement II Seminar",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3G03",
    name: "Specialized Instructional Strategies (SIS) II",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3H03",
    name: "Working with Families and Teams",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3IP3",
    name: "Inquiry Project",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3MD3",
    name: "Research Methods for Applied Psychology in Human Behaviour",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3O03",
    name: "Curriculum Theory and Approaches",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3P03",
    name: "Learning Environment II",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3Q03",
    name: "Health, Safety & Nutrition",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3RS3",
    name: "ABA Research Designs",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3ST3",
    name: "Statistics for Applied Psychology in Human Behaviour",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3XP6",
    name: "ECS Practicum II",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "3XS3",
    name: "Theory to Practice I and II",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4CB3",
    name: "Treating Challenging Behaviour II",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4HB3",
    name: "Seminar in Applied Psychology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4HC3",
    name: "Seminar in Applied Psychology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4HD3",
    name: "Seminar in Applied Psychology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4HE3",
    name: "Advanced Seminar in Applied Lifespan & Developmental Psychology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4HF3",
    name: "Advanced Seminar in Applied Social Psychology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4HG3",
    name: "Advanced Seminar in Mental Health",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4I03",
    name: "Parent and Staff Training",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4IP3",
    name: "Senior Inquiry Project",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4J03",
    name: "Transition Planning and Implementation",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4N03",
    name: "Principles of Ethical Practice",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4RP6",
    name: "Independent Research Project",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4SC6",
    name: "Science Communication in the Behavioural Sciences",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4U03",
    name: "Inclusion in the ECE Classroom",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4V12",
    name: "ECS Practicum III",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4VS3",
    name: "Theory to Practice III",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "HUMBEHV",
    code: "4W03",
    name: "Supervision for Leadership and Quality",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "1BD3",
    name: "2D Practices in Art",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "1CR3",
    name: "Performance: Body and Voice",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "1HA3",
    name: "Introduction to Histories of the Arts",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "1PA3",
    name: "Perspectives A: Arts in Society: Social Constructions of Class, Race and Gender",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "1PB3",
    name: "Perspectives B: Arts in Society: Technology and the Environment",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "1RP3",
    name: "Project Production 1",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "1RR3",
    name: "Project Development 1",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "1SS3",
    name: "3D Practices in Art",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "1T03",
    name: "Theatre, Performance, and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2AD3",
    name: "Acting as Devising I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2AS3",
    name: "Performance, Art and Visual Culture in East and South Asia",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2BB3",
    name: "Designing for Devised Performance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2CC3",
    name: "Performance, Art, and Visual Culture in Canada",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2CD3",
    name: "Contemporary Approaches to Drawing Practices",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2CP3",
    name: "Introduction to Critical Curatorial Perspectives",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2DE3",
    name: "Devised Performance Processes",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2DP3",
    name: "Digital Practices",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2EP3",
    name: "3D and Expanded Practices",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2ER3",
    name: "Environmentally Responsible Art",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2FA3",
    name: "Film Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2ME3",
    name: "Performance, Art, and Visual Culture in the Middle East",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2MM3",
    name: "Movies and Me",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2OP3",
    name: "Organizing Performance Space",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2PC3",
    name: "Perspectives C: Arts in the Community",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2PD3",
    name: "Perspectives D: Arts Across Disciplines",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2PM3",
    name: "Contemporary Approaches to Print Media",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2PP3",
    name: "Contemporary Approaches to Painting Practices",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2RP3",
    name: "Project Production 2",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2RR3",
    name: "Project Development 2",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2SP3",
    name: "Contemporary Approaches to Sculpture Practices",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "2US3",
    name: "Understanding Spatial Dynamics and Time in the Arts",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "3EA3",
    name: "Social Practice and Community-Engaged Art",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "3RR3",
    name: "‘Cripping’ Performance: Deaf, Mad and Disabled Performance in Canada",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "4AP3",
    name: "Contemporary Art Practices of Intervention, Performance, and Conceptual Art",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IARTS",
    code: "4CS6",
    name: "Critical Curatorial Studies",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "1EE0",
    name: "Introduction to the IBEHS Co-op Program",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "1EP6",
    name: "Entrepreneurship in Biomedical Innovation: From Bench to Market",
    classification: "Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "1HS0",
    name: "Health Screening and Clinical Safety Training",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "1P10",
    name: "Health Solutions Design Projects I: Introduction to Engineering Fundamentals and Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "2E03",
    name: "Human-Centred Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "2EC0",
    name: "IBEHS Work Term",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "2EE3",
    name: "From Idea to Innovation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "2P03",
    name: "Health Solutions Design Projects II: Introduction to Genetic Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "3A03",
    name: "Biomedical Signals and Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "3E03",
    name: "Fundamentals of Business Strategy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "3EE3",
    name: "Project Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "3H03",
    name: "Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "3I06",
    name: "Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "3P04",
    name: "Health Solutions Design Projects III: Analysis and Decision Making",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "3X03",
    name: "Experiential Placement",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "4A03",
    name: "Biomedical Control Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "4B03",
    name: "Biomechanics",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "4C03",
    name: "Statistical Methods in Biomedical Engineering",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "4D03",
    name: "Introduction to Medical Imaging",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "4E09",
    name: "Health, Engineering Science and Entrepreneurship Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "4EE6",
    name: "Innovators in Scrubs",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "4EI3",
    name: "Unleashing Innovation at The Clinic",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "4F04",
    name: "Biomedical Instrumentation and Measurement",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "4H03",
    name: "Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "4P04",
    name: "Health Solutions Design Projects IV: Economics and Project Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "4QZ3",
    name: "Modelling of Biological Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "5E15",
    name: "Health, Engineering Science and Entrepreneurship Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBEHS",
    code: "5P06",
    name: "Biomedical Capstone Design Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "1AA3",
    name: "Financial Accounting",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "1AB3",
    name: "Perspectives on Canadian Business",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "1AC3",
    name: "Introduction to Language and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "1AD3",
    name: "IBH in the Community",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "1BA3",
    name: "Organizational Behaviour",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "1BB3",
    name: "Insight and Inquiry: Questions to Change the World",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "1BC3",
    name: "Fundamentals of Ethics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "1BD3",
    name: "Introduction to Peace Studies for IBH",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "1LD0",
    name: "Leadership Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "2AA3",
    name: "Introduction to Marketing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "2AB3",
    name: "Information Systems in Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "2AC3",
    name: "Talent Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "2AD3",
    name: "Statistical Data Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "2AE3",
    name: "Critical Thinking",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "2AF3",
    name: "Global Business Experience",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "2BA3",
    name: "Managerial Accounting",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "2BB3",
    name: "Introduction to Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "2BC3",
    name: "Operations Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "2BD3",
    name: "Moral Issues",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "2BE3",
    name: "Canadian Business History: the Canadian Experience in International Perspective",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "2BF3",
    name: "History of Capitalism",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "2LD0",
    name: "Leadership Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "3AA3",
    name: "Relationship Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "3AB3",
    name: "Applied Marketing Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "3AC3",
    name: "Corporate Finance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "3AD3",
    name: "Cross-Cultural Communication",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "3BA3",
    name: "Understanding Entrepreneurship and Social Entrepreneurship From a Historical and Theoretical Lens",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "3BB3",
    name: "Organizational Strategy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "3BC3",
    name: "Poverty, Privilege and Protest in Canadian History",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "3BD3",
    name: "Interpersonal Communication",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "3BE3",
    name: "Operations Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "4AA3",
    name: "Leadership: Fostering Effective Communication Through Visual Literacy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "4CE3",
    name: "Community Engagement Capstone",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "4LD3",
    name: "Leadership Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "IBH",
    code: "4SE3",
    name: "Social Entrepreneurship Capstone",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "1A03",
    name: "Introduction to Indigenous Studies",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "1AA3",
    name: "Introduction to Contemporary Indigenous Studies",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "1B03",
    name: "Reconciling What? Indigenous Relations in Canada",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "2A03",
    name: "Indigenous Peoples’ Spirituality",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "2B03",
    name: "History of Indigenous Peoples’ Sovereignty",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "2BB3",
    name: "Contemporary Indigenous Knowledge and Societies",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "2C03",
    name: "Current Issues in Indigenous Studies: Selected Topics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "2D03",
    name: "Traditional Indigenous Ecological Knowledge",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "2F03",
    name: "Residential Schools in Canada: History and Impact",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "2G03",
    name: "Indigenous Perspectives on Peace and Conflict",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "2H03",
    name: "Indigenous Celebrity",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "2J03",
    name: "Indigenous Experiential Education",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "2K03",
    name: "Indigenous Futurisms and Wonderworks",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "2M03",
    name: "Indigenous Research Methods and Ethics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "2MM3",
    name: "Indigenous Ways of Knowing: Theory",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "2U03",
    name: "Indigenous Textiles and Design",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3C03",
    name: "Study of Haudenosaunee First Nations in Contemporary Times",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3CC3",
    name: "Contemporary Indigenous Societies: Selected Topics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3D03",
    name: "Contemporary Native Literature in Canada",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3E03",
    name: "Contemporary Native Literature in the United States",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3EE3",
    name: "Indigenous Film",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3F03",
    name: "Indigenous Art and Visual Culture in Canada, 1960 to the Present",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3G03",
    name: "Indigenous Creative Arts and Drama: Selected Topics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3H03",
    name: "Indigenous Medicine I: Philosophy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3HH3",
    name: "Indigenous Medicine II: Practical",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3J03",
    name: "Government and Politics of Indigenous People",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3K03",
    name: "Indigenous Human Rights",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3L03",
    name: "Indigenous Independent Study",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3N03",
    name: "Indigenous Women: Land, Rights, and Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3P03",
    name: "Haudenosaunee Health, Diet and Traditional Botany",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3Q03",
    name: "Histories of Indigenous Sport and Recreation",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3R03",
    name: "Ogweho:weh Experiential Land-Based Learning",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3S03",
    name: "Other-than-Human Worlds and Relations",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3T03",
    name: "Haudenosaunee Oral Traditions, Narrative and Culture",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "3VV3",
    name: "The Indian Act: A Social Problem",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "4A03",
    name: "Storytelling and Environmental Conservation",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "4B03",
    name: "Indigenous Literary Governance and Resistance",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "4C03",
    name: "Contemporary Indigenous Societies and Issues: Selected Topics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "4D03",
    name: "Indigenous Critical Theory and Inquiry",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "4G03",
    name: "Indigenous Genocide",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "4HH3",
    name: "Indigenous Health and Interdisciplinary Approaches",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "4IW3",
    name: "Twenty-First Century Indigenous Writing and Film",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "4J03",
    name: "Indigenous Erotics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "4L03",
    name: "Indigenous Community Research Experience",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "4LF3",
    name: "Diné and Dene Literature and Film",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "4RI3",
    name: "Colonialism and Resistance in Representations of Indigenous Womanhood",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INDIGST",
    code: "4T06",
    name: "Honours Thesis",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INNOVATE",
    code: "1X03",
    name: "The World of Entrepreneurship",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INNOVATE",
    code: "1Z03",
    name: "Artificial Intelligence",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INNOVATE",
    code: "2SI3",
    name: "Social Innovations",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INNOVATE",
    code: "2X03",
    name: "Lean Startup",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INNOVATE",
    code: "2Z03",
    name: "Sprint Methodologies",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INNOVATE",
    code: "3EX3",
    name: "Experiential Learning in Innovation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INNOVATE",
    code: "3X03",
    name: "Persuasion, Pitching Skills and Marketing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INNOVATE",
    code: "3Z03",
    name: "From Founder to CEO",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INNOVATE",
    code: "3ZZ3",
    name: "Imagining and Navigating the Future",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INNOVATE",
    code: "4EX6",
    name: "Founders Startup",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INSPIRE",
    code: "1A03",
    name: "Multidisciplinary Experiential Learning Opportunities",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INSPIRE",
    code: "1PL3",
    name: "Personal Leadership Through University Transition",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INSPIRE",
    code: "2GS3",
    name: "Global Questions in Sustainability",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INSPIRE",
    code: "3AR3",
    name: "Exploring Leadership in Athletics & Recreation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INSPIRE",
    code: "3AS3",
    name: "Language and Communication in Autism Spectrum Disorder",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INSPIRE",
    code: "3EL1",
    name: "Experiential Learning Opportunities",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INSPIRE",
    code: "3EL2",
    name: "Experiential Learning Opportunities",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INSPIRE",
    code: "3EL3",
    name: "Experiential Learning Opportunities",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INSPIRE",
    code: "3II3",
    name: "Multidisciplinary Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INSPIRE",
    code: "3MP3",
    name: "A World of Big Questions and Multiple Perspectives",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INSPIRE",
    code: "3WW3",
    name: "Exploring Leadership in University Orientation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INTENG",
    code: "2A03",
    name: "International Engagement at Home",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INTENG",
    code: "2A03",
    name: "International Engagement at Home",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "INTENG",
    code: "3A03",
    name: "International Engagement Capstone",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ISCI",
    code: "1A24",
    name: "Integrated Science I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ISCI",
    code: "2A18",
    name: "Integrated Science II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ISCI",
    code: "3A12",
    name: "Integrated Science III",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ISCI",
    code: "3Z09",
    name: "Integrated Science III for Exchange Students",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ISCI",
    code: "4A12",
    name: "Integrated Science IV",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ISCI",
    code: "4ZF0",
    name: "Integrated Science Field Work",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ITALIAN",
    code: "1A03",
    name: "Intermediate Italian I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ITALIAN",
    code: "1AA3",
    name: "Intermediate Italian II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ITALIAN",
    code: "1Z06",
    name: "Beginners Intensive Italian",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ITALIAN",
    code: "2Z03",
    name: "Intermediate Italian I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ITALIAN",
    code: "2ZZ3",
    name: "Intermediate Italian II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ITALIAN",
    code: "3X03",
    name: "Italy Today Through Film (Taught in English)",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ITALIAN",
    code: "3Z03",
    name: "Advanced Italian I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "ITALIAN",
    code: "4II3",
    name: "Independent Study",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "JAPANESE",
    code: "1Z06",
    name: "Beginners Intensive Japanese",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "JAPANESE",
    code: "2X03",
    name: "Japanese Anime (Taught in English)",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "JAPANESE",
    code: "2Z03",
    name: "Intermediate Intensive Japanese I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "JAPANESE",
    code: "2ZZ3",
    name: "Intermediate Intensive Japanese II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "1A03",
    name: "Human Anatomy and Physiology I",
    classification: "Anatomy Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "1AA3",
    name: "Human Anatomy and Physiology II",
    classification: "Anatomy Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "1E03",
    name: "Motor Control and Learning",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "1F03",
    name: "Human Nutrition and Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "1K03",
    name: "Foundations in Kinesiology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "1Y03",
    name: "Human Anatomy and Physiology I",
    classification: "Anatomy Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "1YY3",
    name: "Human Anatomy and Physiology II",
    classification: "Anatomy Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "2A03",
    name: "Biomechanics",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "2C03",
    name: "Neuromuscular Exercise Physiology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "2CC3",
    name: "Cardiorespiratory and Metabolic Exercise Physiology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "2E03",
    name: "Musculoskeletal Anatomy",
    classification: "Anatomy Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "2F03",
    name: "Growth, Maturation and Physical Activity in Children and Youth",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "2G03",
    name: "Health Psychology",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "2Y03",
    name: "Human Anatomy and Physiology I",
    classification: "Anatomy Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "2YY3",
    name: "Human Anatomy and Physiology II",
    classification: "Anatomy Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3AA3",
    name: "Biomechanics II",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3B03",
    name: "Adapted Physical Activity",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3E03",
    name: "Neural Control of Human Movement",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3F03",
    name: "Athletic Training & Conditioning",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3H03",
    name: "Exercise Psychology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3HN3",
    name: "Human Neurophysiology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3K03",
    name: "Sports Injuries",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3L03",
    name: "Exercise Testing and Prescription",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3N03",
    name: "Ergonomics I: Workplace Injury Risk Assessment",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3Q03",
    name: "Motor Development Across the Lifespan",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3RP3",
    name: "Kinesiology Research Practicum",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3U03",
    name: "Human Growth and Maturation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3V03",
    name: "Sport Psychology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3W03",
    name: "Cardiovascular Physiology of Exercise",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3Y03",
    name: "Human Nutrition and Metabolism",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "3Z03",
    name: "Neuromuscular Plasticity in Health and Disease",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4A03",
    name: "Advanced Biomechanics",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4AA3",
    name: "Applied Biomechanics",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4B03",
    name: "Cardiovascular Disease: Pathophysiology and Rehabilitation",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4C03",
    name: "Integrative Physiology of Human Performance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4D03",
    name: "Psychophysiology of Healthy, Active Living",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4EE3",
    name: "Professional Placement in Kinesiology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4GG3",
    name: "Clinical Biomechanics",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4H03",
    name: "Physical Activity Behaviour Change",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4J03",
    name: "Functional Anatomy",
    classification: "Anatomy Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4KK3",
    name: "Fundamentals of Rehabilitation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4Q03",
    name: "Paediatric Exercise Physiology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4RR6",
    name: "Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4RR9",
    name: "Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4S03",
    name: "Physical Activity in Chronic Health Impairments",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4SS3",
    name: "Human Aging: Biological and Lifestyle Influences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4TT3",
    name: "Human Robotics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4UU3",
    name: "Selected Topics in Kinesiology I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4VV3",
    name: "Selected Topics in Kinesiology II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4W03",
    name: "Exploring Movement and Posture",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4Y03",
    name: "Cognitive Neuroscience of Exercise",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KINESIOL",
    code: "4Z03",
    name: "Scientific Computing and Wearable Technology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KOREAN",
    code: "1Z03",
    name: "Introductory Korean I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KOREAN",
    code: "1ZZ3",
    name: "Introductory Korean II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "KOREAN",
    code: "2X03",
    name: "Korean Pop-Culture (Taught in English)",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LATAM",
    code: "2A03",
    name: "Introduction to Latin American and Latinx Studies",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LATAM",
    code: "3A03",
    name: "Critical Contemporary Issues in Latin American and Latinx Studies",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LATIN",
    code: "1Z03",
    name: "Beginners Intensive Latin I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LATIN",
    code: "1ZZ3",
    name: "Beginners Intensive Latin II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LATIN",
    code: "2A03",
    name: "Intermediate Latin I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LATIN",
    code: "2AA3",
    name: "Intermediate Latin II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LATIN",
    code: "3AA3",
    name: "Latin Prose",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LATIN",
    code: "3BB3",
    name: "Topics in Latin Literature",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LATIN",
    code: "3H03",
    name: "Topics in Latin Poetry",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LATIN",
    code: "4T03",
    name: "Independent Study in Latin",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "1D03",
    name: "Medical Imaging Physics",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "2A03",
    name: "Research Methods in Life Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "2BP3",
    name: "Biophysics of the Cell and Living Organisms",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "2CC3",
    name: "Fundamentals of Neuroscience",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "2D03",
    name: "Behavioural Processes",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "2G03",
    name: "Genes, Genomes and Society",
    classification: "Genetics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "2L03",
    name: "Living Systems Laboratory",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "2N03",
    name: "Human Nutrition for Life Sciences",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "2X03",
    name: "Environmental Change and Human Health",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3AA3",
    name: "Human Pathophysiology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3BB3",
    name: "Neurobiology of Disease",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3BM3",
    name: "Implanted Biomaterials",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3BP3",
    name: "Modelling Life",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3E03",
    name: "Reproductive Endocrinology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3EP3",
    name: "Life Sciences Applied Placement",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3G03",
    name: "Introduction to Epidemiology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3J03",
    name: "Human Biomechanics",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3K03",
    name: "Neural Control of Human Movement",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3L03",
    name: "Laboratory Methods in Life Sciences",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3LA3",
    name: "Introduction to Data Science",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3LL3",
    name: "Living Systems Laboratory Practicum",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3LX3",
    name: "Applied Biostatistics and Scientific Writing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3M03",
    name: "Cellular Dynamics in Health and Disease",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3N03",
    name: "Human Nutritional Toxicology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3P03",
    name: "Communicating Science for Public Audiences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3PP3",
    name: "Communicating Science for Professional Audiences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3Q03",
    name: "Global Human Health and Disease",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3RC3",
    name: "Radioisotopes in Medicine",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3RP3",
    name: "Life Sciences Research Practicum",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3W03",
    name: "Genetic and Epigenetic Determinants of Health: Role in Health Disparity",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3XX3",
    name: "Peer Mentoring in the Life Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "3Z03",
    name: "Life Sciences Inquiry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4A03",
    name: "Independent Study",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4B09",
    name: "Independent Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4C12",
    name: "Independent Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4CM3",
    name: "Foundations of Disease States Inquiry Lab",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4D15",
    name: "Independent Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4DD3",
    name: "Racism & Health Inequities in Science & Health Care",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4E03",
    name: "Science & Storytelling",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4EP6",
    name: "Life Sciences Advanced Placement",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4F03",
    name: "Emerging Paradigms in Environmental Change and Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4H03",
    name: "Regeneration: What Can We Learn From Animal Models?",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4I03",
    name: "Research Seminar",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4J03",
    name: "Science Communication in the Media",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4L03",
    name: "Our Invisible Body: Microbes and Human Health",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4M03",
    name: "Research Seminar",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4N03",
    name: "Research Seminar",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4O03",
    name: "Research Seminar",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4P03",
    name: "Research Seminar",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4Q03",
    name: "Research Seminar",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4U03",
    name: "Mechanisms of Disease",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4V03",
    name: "Extracellular Vesicles in Health and Disease",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4W03",
    name: "Advanced Topics in Nutrition",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4X03",
    name: "The Biopsychology of Sex",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4XX3",
    name: "The Synapse",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LIFESCI",
    code: "4Y03",
    name: "Applied Biomechanics",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "1A03",
    name: "Introduction to Linguistics: Speaking, Signing and Hearing",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "1AA3",
    name: "Introduction to Linguistics: Words, Sentences and Meaning",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "1E03",
    name: "Introduction to English Linguistics I",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "1EE3",
    name: "Introduction to English Linguistics II",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "1Z03",
    name: "Structure of Modern English I",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "1ZZ3",
    name: "Structure of Modern English II",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "2D03",
    name: "Research Methods",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "2DD3",
    name: "Statistics for Language Research",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "2E03",
    name: "The Nature of Texts: From Slang to Formal Discourse",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "2FL3",
    name: "Introduction to Forensic Linguistics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "2L03",
    name: "Phonetics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "2LC3",
    name: "Historical Linguistics: Language Evolution and Change",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "2LL3",
    name: "Languages of the World and Linguistic Universals",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "2PH3",
    name: "Phonology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "2PS3",
    name: "Psycholinguistics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "2RP3",
    name: "Individual Practicum in Indigenous Language Revitalization",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "2S03",
    name: "Language and Society",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "2SL3",
    name: "Introduction to American Sign Language",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "2SY3",
    name: "Syntax",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3AA3",
    name: "Applied Linguistics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3AS3",
    name: "Language and Communication in Autism Spectrum Disorder",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3C03",
    name: "Child Language Acquisition",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3DS3",
    name: "ASL & Deaf Studies",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3E03",
    name: "Teaching English as a Second Language (ESL)",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3F03",
    name: "Anatomy and Physiology for Speech, Language and Hearing",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3II3",
    name: "Semantics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3LA3",
    name: "Introduction to Second Language Acquisition",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3M03",
    name: "Morphology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3NL3",
    name: "Cognitive Neuroscience of Language",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3P03",
    name: "Pragmatics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3PG3",
    name: "Introduction to Programming for Linguistics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3RP3",
    name: "Individual Research Practicum",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3SL3",
    name: "Intermediate American Sign Language",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "3TT3",
    name: "Perspectives on Translation",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4AS3",
    name: "Topics in Advanced Semantics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4BP3",
    name: "Bilingual Phonology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4D03",
    name: "Computers and Linguistic Analysis",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4EL3",
    name: "Laboratory in Experimental Linguistics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4G03",
    name: "Language, Sex and Gender",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4HL3",
    name: "Heritage Languages in the Hamilton Diaspora",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4II3",
    name: "Independent Study",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4LB3",
    name: "Advanced Phonetics and Phonology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4LC3",
    name: "Advanced Syntax and its Interfaces",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4LX3",
    name: "The Structure of X",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4NN3",
    name: "Cognitive Neurolinguistics Laboratory",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4PL3",
    name: "Advanced Programming for Linguistics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4R03",
    name: "Cross-Cultural Communication",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4S03",
    name: "Interpersonal Communication",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4SL3",
    name: "SLP Practicum",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4SS3",
    name: "Seminar in Sociolinguistics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4TE3",
    name: "TESL Practicum",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4XX3",
    name: "Topics in Linguistic Theory",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "LINGUIST",
    code: "4Y06",
    name: "Honours Thesis",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MANTECH",
    code: "3LS3",
    name: "Quality Control and Assurance Methods",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MANTECH",
    code: "3MF3",
    name: "Micro Manufacturing and Fabrication",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MANTECH",
    code: "4AI3",
    name: "Artificial Intelligence",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MANTECH",
    code: "4DA3",
    name: "Design and Advanced Manufacturing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MANTECH",
    code: "4FM3",
    name: "CIM and Flexible Manufacturing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MANTECH",
    code: "4MM3",
    name: "Design and Manufacturing of Machine Elements",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MANTECH",
    code: "4PM3",
    name: "Production Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MANTECH",
    code: "4RM3",
    name: "Robot Mechanics and Mechatronics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1A03",
    name: "Calculus For Science I",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1AA3",
    name: "Calculus For Science II",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1B03",
    name: "Linear Algebra I",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1C03",
    name: "Introduction to Mathematical Reasoning",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1F03",
    name: "Introduction to Calculus and Analytic Geometry",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1K03",
    name: "Advanced Functions",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1LS3",
    name: "Calculus for the Life Sciences I",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1LT3",
    name: "Calculus for the Life Sciences II",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1MM3",
    name: "Applied Calculus",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1MP3",
    name: "Introduction to Mathematical Scientific Computation",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1X03",
    name: "Calculus for Math and Stats I",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1XA3",
    name: "Proofs in Calculus",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1XX3",
    name: "Calculus for Math and Stats II",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1ZA3",
    name: "Engineering Mathematics I",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1ZB3",
    name: "Engineering Mathematics II-A",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "1ZC3",
    name: "Engineering Mathematics II-B",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "2C03",
    name: "Introduction to Differential Equations",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "2ET3",
    name: "Theory and Practice of Teaching Mathematics",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "2FM3",
    name: "Introduction To Mathematical Finance",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "2LA3",
    name: "Applications of Linear Algebra",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "2R03",
    name: "Theory of Linear Algebra",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "2UU3",
    name: "Numbers for Life",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "2X03",
    name: "Advanced Calculus I",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "2XX3",
    name: "Advanced Calculus II",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "2Z03",
    name: "Engineering Mathematics III",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "2ZZ3",
    name: "Engineering Mathematics IV",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3A03",
    name: "Real Analysis I",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3B03",
    name: "Geometry",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3C03",
    name: "Mathematical Physics I",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3CY3",
    name: "Cryptography",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3D03",
    name: "Mathematical Physics II",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3DC3",
    name: "Discrete Dynamical Systems and Chaos",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3ET3",
    name: "Mathematics Teaching Placement",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3F03",
    name: "Ordinary Differential Equations",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3FF3",
    name: "Partial Differential Equations",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3FM3",
    name: "Mathematics of Finance",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3G03",
    name: "Problem Solving",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3GR3",
    name: "Abstract Algebra",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3H03",
    name: "Number Theory",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3I03",
    name: "Partial Differential Equations for Engineering",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3IA3",
    name: "Introduction to Analysis",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3MB3",
    name: "Introduction to Modelling",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3NA3",
    name: "Numerical Linear Algebra",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3QC3",
    name: "Introduction to Quantum Computing",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3T03",
    name: "Inquiry in Topology",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3TP3",
    name: "Truth and Provability",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3U03",
    name: "Combinatorics",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3V03",
    name: "Graph Theory",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3X03",
    name: "Complex Analysis I",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "3Z03",
    name: "Inquiry: History of Mathematics",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4A03",
    name: "Real Analysis II",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4AT3",
    name: "Topics in Analysis",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4B03",
    name: "Calculus on Manifolds",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4BT3",
    name: "Topics in Geometry",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4E03",
    name: "Galois Theory",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4ET3",
    name: "Topics in Algebra",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4FM3",
    name: "Financial Markets and Derivatives",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4FT3",
    name: "Topics in Differential Equations",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4GR3",
    name: "Groups and Rings",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4L03",
    name: "Introduction to Mathematical Logic",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4LT3",
    name: "Topics in Logic",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4MB3",
    name: "Mathematical Biology",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4NA3",
    name: "Numerical Methods for Differential Equations",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4P06",
    name: "Senior Research Project",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4TT3",
    name: "Topics in Topology",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4W03",
    name: "Reading in Mathematics",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4WW3",
    name: "Reading in Mathematics II",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "4X03",
    name: "Complex Analysis II",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATH",
    code: "5GT3",
    name: "Graduate Level Topics in Mathematics",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "2A04",
    name: "Introduction to Materials Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "2B03",
    name: "Introduction to the Thermodynamics of Materials",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "2D03",
    name: "Thermodynamics of Alloys and Phase Diagrams",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "2Q03",
    name: "Electronic Properties of Materials",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "3B03",
    name: "Manufacturing Engineering of Multifunctional and Biomedical Materials",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "3C03",
    name: "Applied Thermodynamics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "3E04",
    name: "Mass Transfer",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "3F03",
    name: "High-Temperature Materials Production",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "3J03",
    name: "Statistical Methods for Materials Engineers",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "3M03",
    name: "Mechanical Behaviour of Materials",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "3MF3",
    name: "Materials Fabrication",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "3Q03",
    name: "Materials for Electronic Applications",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "3T04",
    name: "Phase Transformations",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4B03",
    name: "Biomaterials and Tissue Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4C03",
    name: "Modern Iron and Steelmaking",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4D03",
    name: "Corrosion and its Control",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4EX1",
    name: "Engineering Report for Exchange Students",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4FF3",
    name: "Synthesis, Applications and Environmental Impact of Nanomaterials",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4G03",
    name: "Characterization of Nanomaterials",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4H03",
    name: "X-ray Analysis and Functional Properties of Polycrystalline and Thin Film Materials",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4I03",
    name: "Sustainable Manufacturing Processes",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4K06",
    name: "Senior Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4LA2",
    name: "Heat-Treatable Al Alloys",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4LB2",
    name: "Synthesis and Characterization of Biomedical Coatings",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4LF2",
    name: "Synthesis, Properties and Application of Thin Films",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4LS2",
    name: "Physical Metallurgy of Steels",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4ML3",
    name: "Applications of Machine Learning to Materials and Chemical Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4MS4",
    name: "Materials Selection in Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4NN3",
    name: "Computational Modelling in Materials Engineering at the Nano-scale",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4NP3",
    name: "Computational Modelling in Materials Engineering at the Process-Scale",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4P03",
    name: "Properties of Polymeric Materials",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4Q03",
    name: "Materials for Sensors in Big Data and AI Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4T03",
    name: "Properties and Processing of Composites",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4Y03",
    name: "Advanced Biomaterials: Applications and Characterization",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLS",
    code: "4Z06",
    name: "Materials Engineering Capstone",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MATLSBME",
    code: "5P06",
    name: "Integrated Materials & Biomedical Engineering Capstone Design Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHBME",
    code: "5P06",
    name: "Integrated Mechanical & Biomedical Engineering Capstone Design Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "2B03",
    name: "Mechanical Engineering Measurements",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "2BA3",
    name: "Mechanical Engineering Measurements",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "2C04",
    name: "Mechanical Engineering Design Project I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "2D03",
    name: "Mechanical Engineering Design Elements",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "2DA3",
    name: "Mechanical Engineering Design Elements",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "2P04",
    name: "Statics and Mechanics of Materials",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "2Q04",
    name: "Engineering Mechanics: Kinetics and Dynamics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "2QA4",
    name: "Engineering Mechanics: Kinetics and Dynamics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "2W04",
    name: "Thermodynamics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "3A03",
    name: "Engineering Mechanics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "3C03",
    name: "Manufacturing Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "3E03",
    name: "Mechanical Engineering Design Theory",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "3F04",
    name: "Modelling and Numerical Solutions",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "3M03",
    name: "Composite Laboratory I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "3O04",
    name: "Fluid Mechanics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "3R03",
    name: "Heat Transfer",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4AA3",
    name: "Aerodynamics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4B03",
    name: "Topics in Product Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4BB3",
    name: "Biomechanics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4BF3",
    name: "Biofluid Mechanics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4C03",
    name: "Production Systems Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4CC3",
    name: "Experimental and Computational Biomechanics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4D03",
    name: "Manufacturing Processes (Metal Removal)",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4DD3",
    name: "Introduction to Surface Engineering in Manufacturing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4E03",
    name: "Microelectromechanical Systems (MEMS)",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4ES3",
    name: "Energy Storage",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4FM3",
    name: "Advanced Instrumentation and Sensing for Thermo-Fluids",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4H03",
    name: "Mechatronics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4I03",
    name: "Noise Analysis and Control",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4J03",
    name: "Introduction to Computational Fluid Mechanics and Heat Transfer",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4K03",
    name: "Robotics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4M06",
    name: "Mechanical Engineering Capstone Design Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4N03",
    name: "Nanobio Engineering",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4O04",
    name: "Sustainable Energy Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4P03",
    name: "Composite Laboratory II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4Q03",
    name: "Mechanical Vibrations",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4R03",
    name: "Control Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4S03",
    name: "Incompressible Flow",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4SS3",
    name: "Smart Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4T03",
    name: "Finite Element Applications",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4U03",
    name: "Compressible Flow and Turbomachinery",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4V03",
    name: "Thermo-Fluids Systems Design and Analysis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4W03",
    name: "Air Conditioning and Refrigeration Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4X04",
    name: "Independent Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4Y03",
    name: "Internal Combustion Engines",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHENG",
    code: "4Z03",
    name: "CAD/CAM/CAE",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHTRON",
    code: "2MD3",
    name: "Data Structures and Algorithms for Mechatronics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHTRON",
    code: "2MP3",
    name: "Programming for Mechatronics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHTRON",
    code: "2TA4",
    name: "Embedded Systems Design I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHTRON",
    code: "3DX4",
    name: "Dynamic Models and Control of Physical Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHTRON",
    code: "3K04",
    name: "Software Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHTRON",
    code: "3MX3",
    name: "Signals and Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHTRON",
    code: "3TB4",
    name: "Embedded Systems Design II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHTRON",
    code: "3X03",
    name: "Scientific Computation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHTRON",
    code: "4AA4",
    name: "Real-Time Systems and Control Applications",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHTRON",
    code: "4AX3",
    name: "Predictive and Intelligent Control",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MECHTRON",
    code: "4TB6",
    name: "Mechatronics Capstone Design Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "1A03",
    name: "Media Arts",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "2A06",
    name: "Design & Code",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "2B06",
    name: "Time-Based Media",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "2G03",
    name: "Digital Audio",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3AN3",
    name: "Animation",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3B03",
    name: "Digital Cultures",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3BB3",
    name: "New Media Art Practices",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3C03",
    name: "Interactive and Spatial Audio",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3DS3",
    name: "Documentary Strategies",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3EE3",
    name: "Graphic Design",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3EW3",
    name: "Environmental and Wildlife Photography",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3I03",
    name: "Narrative Strategies",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3K03",
    name: "Game Studies",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3L03",
    name: "Game Design",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3MU3",
    name: "Musics, Technologies and Audio Cultures",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3PC3",
    name: "Photographic Collage and Composite Images",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3S03",
    name: "Sound and Image",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3VA3",
    name: "Video Art and Digital Cinema",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "3Z03",
    name: "Production and Critique",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "4F03",
    name: "Topics in Media Arts Production",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDIAART",
    code: "4ST6",
    name: "Senior Thesis Research and Production",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDPHYS",
    code: "3C03",
    name: "Operational Health Physics: Laboratory & Communication",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDPHYS",
    code: "4B03",
    name: "Radioactivity and Radiation Interactions",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDPHYS",
    code: "4D03",
    name: "Imaging in Medicine and Biology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDPHYS",
    code: "4F03",
    name: "Fundamentals of Health Physics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDPHYS",
    code: "4I03",
    name: "Introduction to Biophotonics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDPHYS",
    code: "4RA3",
    name: "Radiation and Radioisotope Methodology I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDPHYS",
    code: "4RB3",
    name: "Radiation and Radioisotope Methodology II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDPHYS",
    code: "4T03",
    name: "Clinical Applications of Physics in Medicine",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDPHYS",
    code: "4U03",
    name: "Radiation Biology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDPHYS",
    code: "4Y06",
    name: "Senior Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "1B03",
    name: "Introduction to Pathology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "1E03",
    name: "Inquiry in Medical Radiation Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "1F03",
    name: "Professions in Medical Radiation Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2A03",
    name: "Patient Care",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2AA3",
    name: "Imaging Procedures in Health Care",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2D03",
    name: "Relational Anatomy I",
    classification: "Anatomy Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2G03",
    name: "Radiographic Skills I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2H03",
    name: "Radiographic Skills II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2I03",
    name: "Pathology and Procedures I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2J15",
    name: "Radiography Clinical Practicum I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2K03",
    name: "Applied Sonographic Physics and Instrumentation I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2L03",
    name: "Abdominal Ultrasonography I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2M03",
    name: "Obstetrical and Gynecologic Ultrasonography I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2N03",
    name: "Sonographic Skills I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2O03",
    name: "Abdominal Ultrasonography II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2P03",
    name: "Obstetrical and Gynecological Ultrasonography II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2Q03",
    name: "Sonographic Skills II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2R15",
    name: "Ultrasonography Clinical Practicum I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2RA3",
    name: "Relational Anatomy II",
    classification: "Anatomy Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2S03",
    name: "Clinical Oncology I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2T03",
    name: "Clinical Oncology II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2U03",
    name: "Radiation Therapy Skills I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2V15",
    name: "Radiation Therapy Clinical Practicum I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2W03",
    name: "Physics and Instrumentation for Radiation Therapy",
    classification: "Physics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2X03",
    name: "Radiobiology and Protection",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2Y03",
    name: "Radiographic Imaging and Instrumentation I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "2ZZ0",
    name: "Pre-Clinical Professional Skills Reassessment I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3AA3",
    name: "Interdisciplinary Health Care",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3B03",
    name: "Quality Management in Medical Radiation Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3DA3",
    name: "Advanced Studies in Computed Tomography",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3DE3",
    name: "Introduction to Magnetic Resonance Imaging",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3DJ3",
    name: "Pediatric Sonography",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3G03",
    name: "Radiographic Imaging and Instrumentation II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3H03",
    name: "Quality Control in Radiography",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3J03",
    name: "Pathology and Procedures II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3K03",
    name: "Computed Tomography",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3L03",
    name: "Radiographic Skills III",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3LA3",
    name: "Radiation Therapy Skills II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3LB3",
    name: "Radiation Therapy Skills III",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3M03",
    name: "Abdominal Ultrasonography III",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3N03",
    name: "Vascular Ultrasonography",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3O03",
    name: "Sonographic Skills III",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3P03",
    name: "Obstetrical and Gynecologic Ultrasonography III",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3Q03",
    name: "Applied Sonographic Physics and Instrumentation II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3R03",
    name: "Musculoskeletal Ultrasonography",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3S03",
    name: "Treatment Planning I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3V03",
    name: "Treatment Planning II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3X03",
    name: "Research Methods in Medical Radiation Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3Y03",
    name: "Ethics for Medical Radiation Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3Z06",
    name: "Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "3ZZ0",
    name: "Clinical Skill Development for Professionals",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "4A15",
    name: "Radiography Clinical Practicum II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "4B15",
    name: "Radiography Clinical Practicum III",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "4C15",
    name: "Ultrasonography Clinical Practicum II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "4D15",
    name: "Ultrasonography Clinical Practicum III",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "4E15",
    name: "Radiation Therapy Clinical Practicum II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "4F15",
    name: "Radiation Therapy Clinical Practicum III",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MEDRADSC",
    code: "4ZZ0",
    name: "Pre-Clinical Professional Skills Reassessment II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MELD",
    code: "1M00",
    name: "Mentorship Lab 1",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MELD",
    code: "1MM0",
    name: "Mentorship Lab 2",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MELD",
    code: "1Q03",
    name: "Critical and Analytic Reading",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MELD",
    code: "1QQ3",
    name: "Grammar, Structure and University Writing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MELD",
    code: "1R03",
    name: "Aural Communication and Academic Culture",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MELD",
    code: "1RR3",
    name: "Oral Communication for Academic and Social Interactions",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MELD",
    code: "1S03",
    name: "Critical Reading, Research and Academic Vocabulary",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MELD",
    code: "1SS3",
    name: "Academic Writing, Reporting and Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MELD",
    code: "1T03",
    name: "Cross-Cultural Perspectives on Language and Language Learning",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MELD",
    code: "1TT3",
    name: "Oral Communication for Academic Discourse",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "1D03",
    name: "Midwifery The Profession I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "1F03",
    name: "Introduction to Research Methods and Critical Appraisal",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "1G03",
    name: "Midwifery The Profession II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "2F03",
    name: "Pharmacotherapy",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "2G06",
    name: "Clinical Skills for Midwifery Practice",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "2H15",
    name: "Normal Childbearing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "2M15",
    name: "Fundamentals in Midwifery 1",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "3A09",
    name: "Interprofessional Practice I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "3F03",
    name: "Midwifery Issues",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "3H15",
    name: "Complications and Consultation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "3I03",
    name: "Advanced Clinical Skills I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "3J06",
    name: "Preparation for Primary Maternity Care",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "3K06",
    name: "Interprofessional Practice II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "3L03",
    name: "Advanced Clinical Skills II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "3M01",
    name: "Elective Placement",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "3M03",
    name: "Advanced Clinical Skills I & II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "3M09",
    name: "Fundamentals in Midwifery 3",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "3N15",
    name: "Fundamentals in Midwifery 2",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "4A15",
    name: "Maternal & Newborn Pathology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MIDWIF",
    code: "4B15",
    name: "Midwifery Clerkship",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOHAWK",
    code: "1Z03",
    name: "Introduction to Mohawk Language and Culture",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOHAWK",
    code: "2Z03",
    name: "Intermediate Mohawk",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "2C03",
    name: "Genetics",
    classification: "Genetics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "3A03",
    name: "Current Topics in Molecular Biology and Genetics",
    classification: "Genetics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "3B03",
    name: "Advanced Cell Biology",
    classification: "Cell Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "3D03",
    name: "Experimental Approaches in Cell Biology",
    classification: "Cell Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "3I03",
    name: "Independent Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "3II3",
    name: "Molecular Genetics of Eukaryotes",
    classification: "Genetics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "3M03",
    name: "Fundamental Concepts of Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "3O03",
    name: "Microbial Genetics",
    classification: "Genetics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "3V03",
    name: "Techniques in Molecular Genetics",
    classification: "Genetics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "3Y03",
    name: "Plant Responses to the Environment",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "4BB3",
    name: "Plant Metabolism and Molecular Biology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "4DD3",
    name: "Molecular Evolution",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "4ED3",
    name: "Evolutionary Developmental Biology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "4G12",
    name: "Senior Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "4H03",
    name: "Molecular Biology of Cancer",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "4K03",
    name: "Research Advances in Biology of Aging",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "4P03",
    name: "Medical Microbiology",
    classification: "Microbiology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MOLBIOL",
    code: "4RR3",
    name: "Human Genetics",
    classification: "Genetics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1A03",
    name: "Introduction to the History of Western Music I",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1AA3",
    name: "Introduction to the History of Western Music II",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1CB3",
    name: "Theory and Analysis I",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1CR3",
    name: "Rudiments of Music",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1DA3",
    name: "Practical Musicianship I",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1DB3",
    name: "Practical Musicianship II",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1E06",
    name: "Solo Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1EE6",
    name: "Solo Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1GB3",
    name: "Ensemble Performance: McMaster Concert Band",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1GC3",
    name: "Ensemble Performance: McMaster University Choir",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1GF3",
    name: "Ensemble Performance: David Gerry Flute Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1GJ3",
    name: "Ensemble Performance: McMaster Jazz Band",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1GP3",
    name: "Ensemble Performance: McMaster Percussion Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1GR3",
    name: "Ensemble Performance: McMaster Symphony Orchestra",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1GW3",
    name: "Ensemble Performance: McMaster Cantemus Vocal Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1HB0",
    name: "Ensemble Performance: McMaster Concert Band",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1HC0",
    name: "Ensemble Performance: McMaster University Choir",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1HF0",
    name: "Ensemble Performance: David Gerry Flute Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1HJ0",
    name: "Ensemble Performance: McMaster Jazz Band",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1HP0",
    name: "Ensemble Performance: McMaster Percussion Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1HR0",
    name: "Ensemble Performance: McMaster Symphony Orchestra",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "1HW0",
    name: "Ensemble Performance: McMaster Cantemus Vocal Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2A03",
    name: "Music of the Worlds Cultures",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2CA3",
    name: "Theory and Analysis II",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2CB3",
    name: "Theory and Analysis III",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2CU3",
    name: "Music and Culture",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2DA3",
    name: "Practical Musicianship III",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2E06",
    name: "Solo Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2EE6",
    name: "Solo Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2F03",
    name: "Music for Film and Television",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2GB3",
    name: "Ensemble Performance: McMaster Concert Band",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2GC3",
    name: "Ensemble Performance: McMaster University Choir",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2GF3",
    name: "Ensemble Performance: David Gerry Flute Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2GJ3",
    name: "Ensemble Performance: McMaster Jazz Band",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2GP3",
    name: "Ensemble Performance: McMaster Percussion Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2GR3",
    name: "Ensemble Performance: McMaster Symphony Orchestra",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2GW3",
    name: "Ensemble Performance: McMaster Cantemus Vocal Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2II3",
    name: "Popular Music in North America and the United Kingdom: Post-World War II",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2MC3",
    name: "Psychology of Music",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2MT3",
    name: "Introduction to the Practice of Music Therapy",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2MU3",
    name: "Introduction to Music Therapy Research",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2SI3",
    name: "Singing",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2TT3",
    name: "Broadway and the Popular Song",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2U03",
    name: "Jazz",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "2WW3",
    name: "Woodwinds",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3CP3",
    name: "Constructing Counterpoint",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3E03",
    name: "Solo Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3E06",
    name: "Solo Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3EE3",
    name: "Solo Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3EE6",
    name: "Solo Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3GA3",
    name: "Ensemble Performance: Accompanying",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3GB3",
    name: "Ensemble Performance: McMaster Concert Band",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3GC3",
    name: "Ensemble Performance: McMaster University Choir",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3GF3",
    name: "Ensemble Performance: David Gerry Flute Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3GJ3",
    name: "Ensemble Performance: McMaster Jazz Band",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3GP3",
    name: "Ensemble Performance: McMaster Percussion Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3GR3",
    name: "Ensemble Performance: McMaster Symphony Orchestra",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3GW3",
    name: "Ensemble Performance: McMaster Cantemus Vocal Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3J03",
    name: "Orchestration and Arranging",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3JJ3",
    name: "Topics in Music History: Music Before c. 1750",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3K03",
    name: "Brass Methods",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3KK3",
    name: "Topics in Music History: Music from c. 1750-c. 1900",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3O03",
    name: "Conducting",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3P03",
    name: "Percussion Methods",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3SI3",
    name: "Vocal Pedagogy",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3SS3",
    name: "Special Studies in Chamber Music or Accompanying I",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3V03",
    name: "Foundations of Music Education",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3WW3",
    name: "Woodwind Pedagogy",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "3X03",
    name: "Independent Study",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4C03",
    name: "Advanced Studies in Harmony and Counterpoint",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4E03",
    name: "Solo Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4E06",
    name: "Solo Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4E09",
    name: "Solo Performance, Diploma",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4EE3",
    name: "Solo Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4EE6",
    name: "Solo Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4EE9",
    name: "Solo Performance, Diploma",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4GA3",
    name: "Ensemble Performance: Accompanying",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4GB3",
    name: "Ensemble Performance: McMaster Concert Band",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4GC3",
    name: "Ensemble Performance: McMaster University Choir",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4GF3",
    name: "Ensemble Performance: David Gerry Flute Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4GJ3",
    name: "Ensemble Performance: McMaster Jazz Band",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4GP3",
    name: "Ensemble Performance: McMaster Percussion Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4GR3",
    name: "Ensemble Performance: McMaster Symphony Orchestra",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4GW3",
    name: "Ensemble Performance: McMaster Cantemus Vocal Ensemble",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4H03",
    name: "Investigating Music",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4K03",
    name: "Brass Methods",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4M03",
    name: "String Methods",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4N03",
    name: "Choral Methods",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4OC3",
    name: "Advanced Conducting: Choral",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4OI3",
    name: "Advanced Conducting: Instrumental",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4SS3",
    name: "Special Studies in Chamber Music or Accompanying II",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4X03",
    name: "Advanced Independent Study",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4Y03",
    name: "Topics in Music History: Advanced Musicology Seminar",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4Z03",
    name: "Composing Music",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSIC",
    code: "4ZZ3",
    name: "Advanced Composition",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSICCOG",
    code: "2MP3",
    name: "Introduction to Music Cognition",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSICCOG",
    code: "3QQ3",
    name: "Experimental Laboratory in Music Cognition I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSICCOG",
    code: "3SP3",
    name: "The Science of Performance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSICCOG",
    code: "4D06",
    name: "Thesis in Music Cognition",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSICCOG",
    code: "4MP3",
    name: "Neuroscience of Music",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "MUSICCOG",
    code: "4QQ3",
    name: "Experimental Laboratory in Music Cognition II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "2BB3",
    name: "Research Practicum in Cellular/Molecular Neuroscience",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "2CC3",
    name: "Research Practicum in Systems/Circuits Neuroscience",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "2DD3",
    name: "Research Practicum in Behavioural/Cognitive Neuroscience",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "2XN0",
    name: "Neuroscience Tutorial",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "3BB3",
    name: "Individual Lab Study in Cellular/Molecular Neuroscience",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "3BB6",
    name: "Individual Lab Study in Cellular/Molecular Neuroscience",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "3CC3",
    name: "Individual Lab Study in Systems/Circuits Neuroscience",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "3CC6",
    name: "Individual Lab Study in Systems/Circuits Neuroscience",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "3DD3",
    name: "Individual Lab Study in Behavioural/Cognitive Neuroscience",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "3DD6",
    name: "Individual Lab Study Behavioural/Cognitive Neuroscience",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "3E03",
    name: "Neuroscience Lab",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "3J03",
    name: "Visual Neuroscience",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "3MN3",
    name: "Computational Models in Neuroscience",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "3SN3",
    name: "Neural Circuits",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "4L09",
    name: "Neuroscience Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "4L12",
    name: "Neuroscience Senior Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NEUROSCI",
    code: "4S03",
    name: "Neuroscience Seminar",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NEXUS",
    code: "2A03",
    name: "Impact of Infectious Disease on Individuals and Society",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NEXUS",
    code: "4A06",
    name: "How to Survive a Pandemic: Capstone Project for Nexus Minor",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "1F03",
    name: "Introduction to Nursing and Health I for Basic Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "1G03",
    name: "Introduction to Nursing and Health II for Basic Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "1I02",
    name: "Introduction to Nursing Practice for Basic Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "1J02",
    name: "Professional Nursing Practice I for Basic Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "1K02",
    name: "Community Engagement and Citizenship for Basic Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "1RP0",
    name: "Reintegration Course",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "2A04",
    name: "Introduction to Professional RN Practice I for Post Diploma RPN Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "2AA3",
    name: "Professional RN Practice II for Post Diploma RPN Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "2I04",
    name: "Introduction to Professional Nursing and Health for Accelerated Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "2J04",
    name: "Professional Nursing Practice II for Accelerated Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "2L03",
    name: "Professional Nursing Practice II for Basic Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "2MM3",
    name: "Nursing Concepts in Health and Illness I for Basic Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "2NN3",
    name: "Nursing Concepts in Health and Illness II for Basic Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "2P03",
    name: "Professional Nursing Practice III for Basic Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "2U04",
    name: "Introduction to Nursing Practice I for Accelerated Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "2V04",
    name: "Nursing Concepts in Health & Illness for Accelerated Stream I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3A04",
    name: "Clinical Reasoning in RN Practice for Post Diploma RPN Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3CN3",
    name: "Nursing Practice with the Community: Populations, Partnerships, Politics and Power",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3IH3",
    name: "Introduction to Indigenous Health Policy and Practice",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3QA3",
    name: "Professional Community Nursing Practice",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3QN3",
    name: "Nursing Practice in Northern Communities",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3RS3",
    name: "Nursing Concepts in Health and Illness III for Post Diploma RPN Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3RT3",
    name: "Nursing Concepts in Health and Illness IV for Post Diploma RPN Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3RY4",
    name: "Professional Nursing Practice V for Post Diploma RPN Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3SS3",
    name: "Nursing Concepts in Health and Illness III for Basic Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3TT3",
    name: "Nursing Concepts in Health and Illness IV for Basic Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3V03",
    name: "Nursing Concepts in Health & Illness for Accelerated Stream II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3X04",
    name: "Professional Nursing Practice IV",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3Y04",
    name: "Professional Nursing Practice V",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3ZA3",
    name: "Professional Nursing Practice III for Accelerated Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "3ZB3",
    name: "Professional Nursing Practice IV for Accelerated Stream",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "4H03",
    name: "Introduction to Concepts in Global Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "4J07",
    name: "Professional Nursing Practice VI",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "4K10",
    name: "Professional Practice and the New Graduate",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "4P04",
    name: "Advanced Nursing Concepts I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "NURSING",
    code: "4Q03",
    name: "Advanced Nursing Concepts II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "OJIBWE",
    code: "1Z03",
    name: "Introduction to Ojibwe Language and Culture",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "OJIBWE",
    code: "2Z03",
    name: "Intermediate Ojibwe",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "1A03",
    name: "Peace, Justice, Human Rights",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "1VM3",
    name: "Voices at Mac: Understanding our World",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "2A03",
    name: "Conflict Transformation: Theory and Practice",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "2B03",
    name: "Human Rights and Social Justice",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "2C03",
    name: "Peace, Justice, and Popular Culture",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "2CS3",
    name: "Decolonization and Activism: Creating Social Change",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "2GW3",
    name: "A History of Global War",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "2LS3",
    name: "Language and Society",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "2XX3",
    name: "Social & Structural Determinants of Health",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "3B03",
    name: "Peace-Building and Health Initiatives",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "3C03",
    name: "Researching Global Peace and Social Justice",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "3CY3",
    name: "Children, Youth & Media",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "3D03",
    name: "Globalization and Peace",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "3GG3",
    name: "Theories of Decolonization and Resistance",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "3P03",
    name: "Practicum: Practical Peace Building",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "3RR3",
    name: "Race, Religion and Media",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "3V03",
    name: "Global Anglophone Literature and Film",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "3W03",
    name: "Contemporary Native Literature in Canada",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "3X03",
    name: "Contemporary Native Literature in the United States",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "3XX3",
    name: "Human Rights in History",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "3Y03",
    name: "Special Topics in Peace and Justice",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "4B03",
    name: "Independent Research",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "4FC3",
    name: "Community Engaged Experiential Learning",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "4G03",
    name: "Peace Through Health: Praxis",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "4GG3",
    name: "Nation and Genocide in the Modern World",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "4L03",
    name: "Peace, Environment and Health",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "4RR3",
    name: "Truth and Reconciliation After Atrocity",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PEACJUST",
    code: "4ST3",
    name: "Special Topics Seminar",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHARMAC",
    code: "3A06",
    name: "Introduction to Pharmacology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHARMAC",
    code: "3B06",
    name: "Methods in Pharmacology",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PHARMAC",
    code: "4A03",
    name: "Receptor-Drug Interactions",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHARMAC",
    code: "4AA3",
    name: "Advanced Topics in Pharmacology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHARMAC",
    code: "4C03",
    name: "Principles of Toxicology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHARMAC",
    code: "4D03",
    name: "Drug Design",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHARMAC",
    code: "4E03",
    name: "Social Pharmacology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHARMAC",
    code: "4T15",
    name: "Senior Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "1A03",
    name: "Philosophical Texts",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "1B03",
    name: "Philosophy, Law and Society",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "1E03",
    name: "Philosophical Questions",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "1F03",
    name: "Meaning in Life",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2B03",
    name: "Introductory Logic",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2CT3",
    name: "Critical Thinking",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2D03",
    name: "Bioethics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2E03",
    name: "Classical Chinese Philosophy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2F03",
    name: "Philosophical Psychology",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2G03",
    name: "Social and Political Issues",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2H03",
    name: "Aesthetics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2LA3",
    name: "Latin American Philosophy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2N03",
    name: "Business Ethics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2P03",
    name: "Ancient Greek Philosophy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2Q03",
    name: "Justice, Political Philosophy, and Law",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2S03",
    name: "History of Political Philosophy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2TT3",
    name: "Ethical Issues in Communication",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2U03",
    name: "Philosophy of Health and Medicine",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2X03",
    name: "Early Modern Philosophy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2YY3",
    name: "Ethics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "2ZZ3",
    name: "Philosophy of Love and Sex",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3B03",
    name: "European Philosophy from Nietzsche to World War II",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3C03",
    name: "Advanced Bioethics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3CC3",
    name: "Advanced Ethics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3D03",
    name: "Philosophy of Science",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3E03",
    name: "Philosophy of Language",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3EE3",
    name: "Contemporary Continental Philosophy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3GH3",
    name: "Global Health Ethics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3HH3",
    name: "Metaphysics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3I03",
    name: "Philosophy and Feminism",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3L03",
    name: "Environmental Philosophy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3MI3",
    name: "Philosophy of Mind",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3N03",
    name: "Political Philosophy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3NN3",
    name: "Philosophy of the Enlightenment",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3O03",
    name: "Theory of Knowledge",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3Q03",
    name: "Philosophy of Law",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3SR3",
    name: "Metaphysics of Social Reality",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3T03",
    name: "Philosophy and Race",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3VV3",
    name: "Kant",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3W03",
    name: "Reading Course",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3WP3",
    name: "Modern Women Philosophers",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3XX3",
    name: "Plato",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3YY3",
    name: "Hegel",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "3ZZ3",
    name: "Aristotle",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "4A03",
    name: "Early Modern Philosophy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "4C03",
    name: "Philosophy of Constitutional Law",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "4D03",
    name: "History of Analytic Philosophy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "4F03",
    name: "Issues in Continental Philosophy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "4JP3",
    name: "Topics in Justice, Political Philosophy, and Law",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "4K03",
    name: "Seminar in Ancient Philosophy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "4S03",
    name: "Human Rights and Global Justice",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "4T03",
    name: "Special Topics in Philosophy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "4V03",
    name: "Multidisciplinary Workshop in Applied Ethics and Policy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "4W03",
    name: "Independent Study",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "4XP3",
    name: "Law And Community",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "4YE3",
    name: "Philosophy, Pedagogy And Community",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHILOS",
    code: "4YY3",
    name: "Topics in Ethics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "1A03",
    name: "Introductory Physics",
    classification: "Physics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "1AA3",
    name: "Introduction To Modern Physics",
    classification: "Physics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "1C03",
    name: "Physics for the Chemical and Physical Sciences",
    classification: "Physics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "1CC3",
    name: "Modern Physics for the Chemical and Physical Sciences",
    classification: "Physics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "1D03",
    name: "Introductory Mechanics",
    classification: "Physics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "1E03",
    name: "Waves, Electricity and Magnetic Fields",
    classification: "Physics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "2B03",
    name: "Electricity and Magnetism I",
    classification: "Physics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "2BB3",
    name: "Electricity and Magnetism II",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "2C03",
    name: "Modern Physics",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "2E03",
    name: "Mechanics",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "2NM3",
    name: "Media Numeracy: Telling Stories With Numbers",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "2P03",
    name: "Introductory Laboratory",
    classification: "Physics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "2X00",
    name: "From Classical Physics Into the Quantum World",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "3A03",
    name: "Relativity, Gravity and the Geometry of Spacetime",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "3C03",
    name: "Analytical Mechanics",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "3D03",
    name: "Inquiry in Physics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "3ET3",
    name: "Physics Teaching Placement",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "3K03",
    name: "Thermodynamics and Statistical Mechanics",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "3MM3",
    name: "Quantum Mechanics I",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "3N04",
    name: "Physical Optics",
    classification: "Physics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "3P03",
    name: "Advanced Laboratory",
    classification: "Physics Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "3QI3",
    name: "Introduction to Quantum Information",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "4B03",
    name: "Electromagnetic Theory",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "4E03",
    name: "Particle and Nuclear Physics",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "4F03",
    name: "Quantum Mechanics II",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "4G03",
    name: "Computational Physics",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "4IS3",
    name: "Independent Study",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "4K03",
    name: "Solid State Physics",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "4L03",
    name: "Literature Review",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "4P06",
    name: "Senior Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "4Q03",
    name: "Introduction to Quantum Field Theory",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PHYSICS",
    code: "5GT3",
    name: "Graduate Topics in Physics",
    classification: "Physics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "2A03",
    name: "Python for PNB",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "2QQ3",
    name: "Introductory Independent Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "2XA3",
    name: "Human Perception & Cognition",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "2XB3",
    name: "Neuroanatomy & Neurophysiology",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "2XC3",
    name: "Animal Behaviour & Evolution",
    classification: "Advanced Biology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "2XD3",
    name: "Integrative PNB Through Scientific Writing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "2XE3",
    name: "Descriptive Statistics and Research Methods",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "2XF3",
    name: "Perspectives in PNB",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "2XT0",
    name: "PNB Tutorial",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "3A03",
    name: "Neuroimaging",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "3EE3",
    name: "Perception Laboratory",
    classification: "Psychology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "3EV3",
    name: "Evolutionary Psychology Lab",
    classification: "Psychology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "3HP3",
    name: "History of Psychology",
    classification: "History",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "3L03",
    name: "Neurodevelopment & Plasticity Lab",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "3MM3",
    name: "Cognitive Neuroscience Lab",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "3Q03",
    name: "Independent Library Study",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "3QM3",
    name: "Independent Research in Mental Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "3QM6",
    name: "Independent Research in Mental Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "3QQ3",
    name: "Intermediate Independent Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "3S03",
    name: "Animal Behaviour Lab",
    classification: "Advanced Biology Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "3V03",
    name: "Human Memory Lab",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "3XD3",
    name: "Integrative Mentor: Learning to Write through Student Editing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "3XE3",
    name: "Inferential Statistics and Research Methods",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "4A03",
    name: "Assessment in Children",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "4D06",
    name: "Senior Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "4D09",
    name: "Senior Honours Thesis",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "4E03",
    name: "Social Diversity through the Lens of Cognitive Neuroscience and Psychology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "4J03",
    name: "Inquiry in Psychology, Neuroscience & Behaviour",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "4Q03",
    name: "Senior Independent Library Study",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "4QQ3",
    name: "Senior Independent Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "4QQ6",
    name: "Senior Independent Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PNB",
    code: "4SC6",
    name: "Science Communication in the Behavioural Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLISH",
    code: "1Z03",
    name: "Beginners Polish I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLISH",
    code: "1ZZ3",
    name: "Beginners Polish II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLISH",
    code: "2Z03",
    name: "Intermediate Polish I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLISH",
    code: "2ZZ3",
    name: "Intermediate Polish II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "1AA3",
    name: "Government, Politics, and Power",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "1AB3",
    name: "Politics and Power in a Globalizing World",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2C03",
    name: "Force and Fear, Crime and Punishment",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2D03",
    name: "Canadian Democracy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2EM3",
    name: "Political Economy of the Media",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2F03",
    name: "Politics, Power and Influence in Canada",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2H03",
    name: "Globalization and the State",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2I03",
    name: "Global Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2J03",
    name: "Global Political Economy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2LW3",
    name: "Communication Policy and Law",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2M03",
    name: "Governance, Representation, and Participation in Democracies",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2MN3",
    name: "Reel Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2NN3",
    name: "Politics by Design",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2O06",
    name: "Political Theory",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2PF3",
    name: "Politics of Funny",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2U03",
    name: "Public Policy and Administration",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2US3",
    name: "US Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "2XX3",
    name: "Politics of the Developing World",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3B03",
    name: "Honours Issues in International Relations and Global Public Policy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3BB3",
    name: "Political Communication: Canada and the World",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3C03",
    name: "Government and Politics of Indigenous People",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3CC3",
    name: "Political Authority: 20th-Century Political Theory",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3CL3",
    name: "Constitutional and Public Law in Canada",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3EE3",
    name: "International Relations: North-South",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3EL3",
    name: "Election Law and Policy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3FG3",
    name: "Public Service Leadership",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3G03",
    name: "Ethnicity and Multiculturalism: Theory and Practice",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3GC3",
    name: "Politics of a Dying Planet",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3GG3",
    name: "Federalism",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3H03",
    name: "Honours Issues in Comparative Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3I03",
    name: "Topics in American Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3IP3",
    name: "Intellectual Property",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3J03",
    name: "Honours Issues in Canadian Politics and Canadian Public Policy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3JJ3",
    name: "Provincial Politics in Canada",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3JR3",
    name: "The Rule of Law and Legal and Judicial Reforms in the Developing World",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3K03",
    name: "Migration and Citizenship: Canadian, Comparative and Global Perspectives",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3KA3",
    name: "Indigenous Human Rights",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3KK3",
    name: "Genocide: Sociological and Political Perspectives",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3LA3",
    name: "Religion and Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3LB3",
    name: "Globalization and the World Order",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3LC3",
    name: "Southeast Asian Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3LL3",
    name: "Development and Public Policy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3LP3",
    name: "Topics in Law and Policy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3NN3",
    name: "Statistical Analysis of Primary Data",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3PA3",
    name: "Politics of Pandemics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3PB3",
    name: "Politics from Below",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3PG3",
    name: "Political Geography",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3PR3",
    name: "Practice of Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3Q03",
    name: "The Causes of War",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3RF3",
    name: "The Charter of Rights and Freedoms",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3UU3",
    name: "Reading Course",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3V03",
    name: "Gender and Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3VV3",
    name: "Democratic Theory",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3WP3",
    name: "Working in Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3Y03",
    name: "Democratization and Human Rights",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "3Z03",
    name: "Canadian Public Sector Management",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4AA6",
    name: "Contemporary Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4AL3",
    name: "Pathways: Approaching Life with a Political Science Degree",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4CA3",
    name: "Issues in Canadian Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4CF3",
    name: "Canadian Foreign Policy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4D06",
    name: "International Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4DV3",
    name: "Death and Violence",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4FF3",
    name: "Rights and Justice",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4G06",
    name: "Politics of Public Policy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4GC3",
    name: "Advanced Issues in Global Citizenship",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4GG3",
    name: "Conceptual Issues in Global Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4HH3",
    name: "Critical Theory",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4HR3",
    name: "Human Rights",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4JS3",
    name: "Judicial Studies",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4KB3",
    name: "Non-Western International Relations",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4KC3",
    name: "Comparative Democratization",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4LA3",
    name: "Politics in Latin America",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4LC3",
    name: "Research on Law and Courts",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4NN3",
    name: "Studies in Global Political Economy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4O06",
    name: "Canadian Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4OL3",
    name: "Origins of Law",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4PA3",
    name: "Policy Analysis and Implementation",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4PB3",
    name: "Politics of Borders",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4PE3",
    name: "Global Political Ecology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4PO3",
    name: "Public Opinion",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4Q06",
    name: "Comparative Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4QQ3",
    name: "Issues in International Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4RR3",
    name: "Health Policy in the Industrialized World",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4RT3",
    name: "Radical Political Theory",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4SS3",
    name: "Public Opinion and Policy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4ST3",
    name: "Special Topics in Contemporary Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4UF3",
    name: "US Foreign Policy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4UP3",
    name: "Urban Politics and Governance in the 21st Century: Canadian and Comparative Perspectives",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4WS3",
    name: "Politics of the Welfare State: Contemporary Challenges in Comparative Perspective",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4Y03",
    name: "Domination and Decolonization",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4YR3",
    name: "Child/Youth Rights and Security in Global Political Perspective",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4Z06",
    name: "Honours Essay",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4ZZ3",
    name: "Experiential Learning in Research",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "POLSCI",
    code: "4ZZ6",
    name: "Experiential Learning in Research",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "2CA3",
    name: "CAD for Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "2CE3",
    name: "Chemical Engineering I: Mass Balance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "2EC3",
    name: "Chemical Engineering II: Energy Balance",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "2EE3",
    name: "Electricity and Electronics II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "2I03",
    name: "Industrial Organic Chemistry",
    classification: "Organic Chemistry Lab",
    lab: "🥼",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "2IC3",
    name: "Instrumentation and Control",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "2PL3",
    name: "PLC Programming",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "2SE3",
    name: "Systems Engineering Fundamentals",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "3CE3",
    name: "Chemical Engineering III: Unit and Process Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "3CT3",
    name: "Control Theory I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "3MC3",
    name: "Motion Control and Robotics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "3PL3",
    name: "Advanced PLC Programming and Control",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "4AS3",
    name: "Industrial System Components and Integration",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "4CT3",
    name: "Advanced Control Theory II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "4IC3",
    name: "Industrial Networks and Controllers",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "4IT3",
    name: "Internet Technologies and Databases",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "4MH3",
    name: "Machine Health and Remote Monitoring",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "4MS3",
    name: "Manufacturing Technologies",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "4SS3",
    name: "System Specification and Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "4TR1",
    name: "Capstone Design Project I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PROCTECH",
    code: "4TR3",
    name: "Capstone Design Project II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "1F03",
    name: "Survey of Psychology",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "1FF3",
    name: "Survey of Biological Basis of Psychology",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "1N03",
    name: "Introduction to Psychology, Neuroscience & Behaviour",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "1NN3",
    name: "Foundations of Psychology, Neuroscience & Behaviour",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "1X03",
    name: "Introduction to Psychology, Neuroscience & Behaviour",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "1XX3",
    name: "Foundations of Psychology, Neuroscience & Behaviour",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "2AA3",
    name: "Child Development",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "2AP3",
    name: "Abnormal Psychology: Fundamentals and Major Disorders",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "2B03",
    name: "Personality",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "2C03",
    name: "Social Psychology",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "2E03",
    name: "Sensory Processes",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "2GG3",
    name: "Learning, Measuring, and Shaping Behaviour",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "2H03",
    name: "Human Learning and Cognition",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "2MP3",
    name: "Introduction to Music Cognition",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "2NF3",
    name: "Clinical Neuropsychology",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3A03",
    name: "Audition",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3AB3",
    name: "Adolescent Psychology",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3AC3",
    name: "Human Sexuality",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3AG3",
    name: "Aging",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3B03",
    name: "Special Populations",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3BA3",
    name: "Positive Psychology",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3BN3",
    name: "Cognitive Neuroscience",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3C03",
    name: "Child Language Acquisition",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3CB3",
    name: "Attitudes and Persuasion",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3CC3",
    name: "Forensic Psychology",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3D03",
    name: "The Multisensory Mind",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3EV3",
    name: "Evolution and Mental Health",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3F03",
    name: "Evolution and Human Behaviour",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3FA3",
    name: "Neuroscience of Learning and Memory",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3GG3",
    name: "Essentials of Developmental Psychology",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3JJ3",
    name: "Socio-Emotional Development",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3M03",
    name: "Motivation and Emotion",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3MT3",
    name: "Psychometrics",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3NL3",
    name: "Cognitive Neuroscience of Language",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3SP3",
    name: "The Science of Performance",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3T03",
    name: "Behavioural Ecology",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3TT3",
    name: "Science of Teaching and Learning",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3UU3",
    name: "Psychology of Language",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3VV3",
    name: "Human Memory",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "3WA3",
    name: "The Mind as a Work of Art",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "4KK3",
    name: "Bayesian Inference",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "4MP3",
    name: "Neuroscience of Music",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "PSYCH",
    code: "4R03",
    name: "Special Topics in Animal Behaviour",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "RUSSIAN",
    code: "1Z03",
    name: "Intensive Beginners Russian I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "RUSSIAN",
    code: "1ZZ3",
    name: "Intensive Beginners Russian II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "RUSSIAN",
    code: "2G03",
    name: "Masterpieces of Russian Literature in Film and TV Series (Taught in English)",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "RUSSIAN",
    code: "2H03",
    name: "Soviet Propaganda in Films and Other Mass Media (Taught in English)",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SANSKRIT",
    code: "2A03",
    name: "Introduction to Sanskrit I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SANSKRIT",
    code: "2B03",
    name: "Introduction to Sanskrit II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SANSKRIT",
    code: "3A03",
    name: "Readings in Sanskrit",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SANSKRIT",
    code: "3B03",
    name: "Advanced Readings in Sanskrit",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "1B03",
    name: "What on Earth is Religion?",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "1SC3",
    name: "The Big Questions: Introduction to Society, Culture & Religion",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2AA3",
    name: "Introduction to Modern Standard Arabic",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2AB3",
    name: "Archaeology and the Bible",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2AM3",
    name: "Abraham in Judaism, Christianity, and Islam",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2AP3",
    name: "Apocalypse, Then and Now",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2AR3",
    name: "Introduction to Modern Standard Arabic II",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2BA3",
    name: "The Bible Then and Now",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2BB3",
    name: "Images of the Divine Feminine",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2BE3",
    name: "The Bible and the Environment",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2BM3",
    name: "Bible and Magic",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2BN3",
    name: "Sex and the City in Buddhism: The Urban Life of Buddhist Nuns in North India",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2CA3",
    name: "Religion and the Arts",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2CH3",
    name: "Introduction to Christianity",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2EE3",
    name: "Prophets, Priests, and Sorcerers",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2ER3",
    name: "Religion, the Body, and the Machine",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2F03",
    name: "Storytelling in Asian Religions",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2FF3",
    name: "Pirates, Pilgrims, and Enslaved in the Mediterranean, 1450-1750",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2G03",
    name: "Religious Themes in Modern Culture",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2GB3",
    name: "Great Books in Asian Religions",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2GG3",
    name: "Who was Jesus?",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2GR3",
    name: "Evil",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2HA3",
    name: "Religion and Health in Antiquity",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2HB3",
    name: "Introduction to the Jewish Scriptures/Old Testament",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2HC3",
    name: "Introduction to Biblical Hebrew I",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2HD3",
    name: "Introduction to Biblical Hebrew II",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2HR3",
    name: "Humour and Religion",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2IR3",
    name: "Hollywood/Bollywood and Indian Religions",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2J03",
    name: "Introduction to Judaism",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2K03",
    name: "Introduction to Buddhism",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2LL3",
    name: "God and Philosophy",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2M03",
    name: "Death and Dying: Comparative Views",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2MT3",
    name: "Asian Meditation Traditions",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2MW3",
    name: "Religion, Magic, and Witchcraft",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2N03",
    name: "Death and Dying: The Western Experience",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2NH3",
    name: "Gods, Ghosts, and Gandharvas: A Survey of Non-Human Realms in Asian Religions",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2NT3",
    name: "The New Testament",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2Q03",
    name: "Introduction to Islam",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2QQ3",
    name: "Cults, Conspiracies and Close Encounters",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2RD3",
    name: "Religion and Diversity",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2RN3",
    name: "Frenemies: Science and Religion in the News",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2RS3",
    name: "Religion and the Stars",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2SA3",
    name: "Encountering the Sacred",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2SB3",
    name: "Introduction to Sanskrit II",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2SG3",
    name: "Spirits, Ghosts, and Demons",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2SK3",
    name: "Introduction to Sanskrit I",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2SP3",
    name: "Sport and/as Religion",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2TA3",
    name: "Islam in North America",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2TT3",
    name: "Religion and Popular Culture in Contemporary Japan",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2UD3",
    name: "Utopias, Dystopias",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2VV3",
    name: "The Bible as Literature",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2WW3",
    name: "Health, Healing and Religion: Western Perspectives",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2WX3",
    name: "Health, Healing and Religion: Comparative Views",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "2YY3",
    name: "The Bible and Film",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3AA3",
    name: "Intermediate Modern Standard Arabic",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3AR3",
    name: "Culture and Religion",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3BE3",
    name: "Buddhist Ethics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3BW3",
    name: "Gender in Ancient Eastern Mediterranean",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3C03",
    name: "Islam in the Modern World",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3CC3",
    name: "Religion and Politics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3DD3",
    name: "Jews and Jesus",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3E03",
    name: "Japanese Film and Religion",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3EE3",
    name: "Sacred Journeys",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3EP3",
    name: "Jewish Ethics and Politics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3ET3",
    name: "Anthropology of Ethics",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3F03",
    name: "Approaches to the Study of Religion",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3FF3",
    name: "Gender and Religion",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3GH3",
    name: "Interdisciplinary Global Health Field Course: Maternal and Infant Health in Morocco",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3HC3",
    name: "Intermediate Hebrew I",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3HD3",
    name: "Intermediate Hebrew II",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3JJ3",
    name: "Social Justice",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3LL3",
    name: "Human Being/Being Human",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3PA3",
    name: "The Birth of Christianity",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3R03",
    name: "Death and the Afterlife in Early Judaism and Christianity",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3RB3",
    name: "Ethnicity, Race, and the Bible",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3RC3",
    name: "Race, Religion, and Coloniality",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3RL3",
    name: "Religion and Law",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3S03",
    name: "The East Asian Religious Tradition",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3SA3",
    name: "Advanced Readings in Sanskrit",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3SB3",
    name: "Advanced Readings in Sanskrit",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3SM3",
    name: "Secular Modernity?",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3U03",
    name: "The Buddhist Tradition in India",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3US3",
    name: "Uses and Abuses of the Bible",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3UU3",
    name: "Zen Buddhism",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3X03",
    name: "Mysticism",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3Y03",
    name: "Love",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "3ZZ3",
    name: "Judaism in the Modern World",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "4AE3",
    name: "Academic Engagement in Society, Culture & Religion",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "4Q03",
    name: "Advanced Readings in Society, Culture and Religion",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "4R06",
    name: "Honours Thesis",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCAR",
    code: "4SC3",
    name: "Society, Culture & Religion Seminar",
    classification: "Humanities",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCICOMM",
    code: "2A03",
    name: "Foundations in Science Communication",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCICOMM",
    code: "2M03",
    name: "Engaging Your World: Science for the Global Citizen",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCICOMM",
    code: "2NM3",
    name: "Media Numeracy: Telling Stories With Numbers",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCICOMM",
    code: "3P03",
    name: "Science Communication in Life Sciences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCICOMM",
    code: "3PP3",
    name: "Communicating Science for Professional Audiences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCICOMM",
    code: "4A03",
    name: "Independent Project in Science Communication",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "1A03",
    name: "Investigating Science: Opportunities & Experiences",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "2A03",
    name: "Peer Mentoring in Science",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "2AR3",
    name: "Foundations of Science: Equity, Justice and Anti-Racism in Science",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "2C00",
    name: "Skills for Career Success in Science",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "2D00",
    name: "Skills for Career Success in Biochemistry",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "2P03",
    name: "Impactful Initiatives in Health",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "3C00",
    name: "Advanced Job Search Skills For Science Co-op Students",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "3D00",
    name: "Advanced Job Search Skills For Co-op Students",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "3EP3",
    name: "Applied Science Placement",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "3EX6",
    name: "Applied Science Placement",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "3IE0",
    name: "Undergraduate Science Internship",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "3IF0",
    name: "Undergraduate Science Internship",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "3IG0",
    name: "Undergraduate Science Internship",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "3IH0",
    name: "Undergraduate Science Internship",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "3RP3",
    name: "Research Practicum",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "3WT0",
    name: "Science Co-op Work Term",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "3WW0",
    name: "Science Co-op Work Term",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "4WT0",
    name: "Science Co-op Work Term",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "4WW0",
    name: "Science Co-op Work Term",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "5WT0",
    name: "Science Co-op Work Term",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SCIENCE",
    code: "5WW0",
    name: "Science Co-op Work Term",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SEP",
    code: "4X03",
    name: "Livable Cities, the Built and Natural Environment",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFGNTECH",
    code: "3DM3",
    name: "Creativity, Innovation and Technology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFGNTECH",
    code: "3EE3",
    name: "Engineering Economics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFGNTECH",
    code: "3FS3",
    name: "Financial Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFGNTECH",
    code: "3MP3",
    name: "Management Principles",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFGNTECH",
    code: "4EM3",
    name: "Legal and Regulatory Issues",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFGNTECH",
    code: "4EN3",
    name: "Entrepreneurial Thinking and Innovation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFGNTECH",
    code: "4LM3",
    name: "Lean Thinking and Practices",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFGNTECH",
    code: "4MK3",
    name: "Fundamentals of Marketing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFGNTECH",
    code: "4PM3",
    name: "Project Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFGNTECH",
    code: "4SE3",
    name: "Technology Ethics and Sustainability",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFGNTECH",
    code: "4SF3",
    name: "Strategic Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFGNTECH",
    code: "4ST3",
    name: "Contemporary Issues in Management",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFGNTECH",
    code: "4TC3",
    name: "Technical Communications",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRBME",
    code: "5P06",
    name: "Integrated Software & Biomedical Engineering Capstone Design Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "2AA4",
    name: "Software Design I",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "2C03",
    name: "Data Structures and Algorithms",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "2DA4",
    name: "Digital Systems and Interfacing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "2DM3",
    name: "Discrete Mathematics with Applications I",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "2FA3",
    name: "Discrete Mathematics and Applications II",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "2GA3",
    name: "Computer Architecture",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "2OP3",
    name: "Object-Oriented Programming",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "2XC3",
    name: "Software Engineering Practice and Experience: Development Basics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3A04",
    name: "Software Design III",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3BB4",
    name: "Software Design II",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3DB3",
    name: "Databases",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3DX4",
    name: "Dynamic Systems and Control",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3FP3",
    name: "Functional Programming",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3GB3",
    name: "Game Design",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3GC3",
    name: "Computer Graphics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3K04",
    name: "Software Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3MD4",
    name: "Safe Software-Intensive Medical Devices",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3MX3",
    name: "Signals and Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3O03",
    name: "Linear Optimization",
    classification: "Math",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3RA3",
    name: "Software Requirements and Security Considerations",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3S03",
    name: "Software Testing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3SH3",
    name: "Operating Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "3XB3",
    name: "Software Engineering Practice and Experience: Binding Theory to Practice",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "4AA4",
    name: "Real-Time Systems and Control Applications",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "4AD3",
    name: "Advanced Databases",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "4C03",
    name: "Computer Networks and Security",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "4E03",
    name: "Performance Analysis of Computer Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "4F03",
    name: "Parallel Computing",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "4G06",
    name: "Software Design IV",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "4HC3",
    name: "Human Computer Interfaces",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "4J03",
    name: "Communications Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "4TE3",
    name: "Continuous Optimization",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "4TH3",
    name: "Theory of Computation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRENG",
    code: "4X03",
    name: "Scientific Computation",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "3CS3",
    name: "Computer Security",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "3IT3",
    name: "Fundamentals of Networking",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "3MA3",
    name: "Contemporary Math for Software Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "3OS3",
    name: "Operating Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "3PR3",
    name: "Procedural and Object Oriented Programming Concepts",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "3RQ3",
    name: "Software Requirements and Specification",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "3ST3",
    name: "Probability and Statistics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4AI3",
    name: "Artificial Intelligence",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4AV3",
    name: "Augmented and Virtual Reality",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4CC3",
    name: "Parallel Programming",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4CG3",
    name: "Computer Graphics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4DA3",
    name: "Data Analytics and Big Data",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4DM3",
    name: "Data Mining",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4DS3",
    name: "Data Structures and Algorithms",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4ES3",
    name: "Real-Time Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4MA3",
    name: "Numerical Linear Algebra and Numerical Optimization",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4NN3",
    name: "Neural Networks and Deep Learning",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4NS3",
    name: "Advanced Network Security",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4SA3",
    name: "Software Architecture",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4SS3",
    name: "Software Security",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4VD3",
    name: "Videogame Development Technology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4VE3",
    name: "Visual Effects and Technology for Animated Production",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SFWRTECH",
    code: "4WP3",
    name: "Advanced Web Programming",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SMRTTECH",
    code: "3CC3",
    name: "Cloud Computing and Internet of Things",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SMRTTECH",
    code: "3DE3",
    name: "Digital Electronics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SMRTTECH",
    code: "4AI3",
    name: "Artificial Intelligence and Machine Learning",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SMRTTECH",
    code: "4ES3",
    name: "Embedded Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SMRTTECH",
    code: "4HM3",
    name: "Human Monitoring and Smart Health Systems",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SMRTTECH",
    code: "4ID3",
    name: "IoT Devices and Networks",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SMRTTECH",
    code: "4SC3",
    name: "Smart Cities and Communities",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "1C03",
    name: "Canadian Society: Social Problems, Social Policy, and the Law",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "1Z03",
    name: "An Introduction to Sociology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2BB3",
    name: "Sociology of Deviance",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2CC3",
    name: "Constructing Deviance",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2DD3",
    name: "Immigration and the Canadian Mosaic",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2EE3",
    name: "Introduction to Indigenous-Settler Relations in Canada",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2FF3",
    name: "The Sociology of ‘Race and Ethnicity",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2GG3",
    name: "Sociology of Education",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2HH3",
    name: "Sociology of Gender",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2JJ3",
    name: "Race, Class, Gender, and Sexuality",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2KK3",
    name: "Introduction to Classical Sociological Theory",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2LL3",
    name: "Introduction to Contemporary Sociological Theory",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2PP3",
    name: "Sociology of Families",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2QQ3",
    name: "Dynamics and Transitions in Intimate Relationships and Families",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2R03",
    name: "Perspectives on Social Inequality",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2RR3",
    name: "Case Studies of Social Inequality",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2SS3",
    name: "Sociology of Work and Occupations",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2T03",
    name: "Sociology of Sport",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2TA3",
    name: "Islam In North America",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2UU3",
    name: "Indigenous Ontologies and Ways of Knowing",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2VV3",
    name: "Law and Society",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2WW3",
    name: "Media and Power",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "2Z03",
    name: "Introduction to Sociological Research",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3A03",
    name: "Advanced Analysis of Classical Sociological Theory",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3B03",
    name: "Selected Topics in the Sociology of Education",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3D03",
    name: "Special Topics in the Sociology of the Family",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3FF3",
    name: "Introduction to Quantitative Research Methods",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3G03",
    name: "Sociology of Health Care",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3K03",
    name: "Special Topics in Sociological Analysis II",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3KK3",
    name: "Genocide: Sociological and Political Perspectives",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3MH3",
    name: "Sociology of Stress and Mental Health",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3MM3",
    name: "Political Sociology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3NN3",
    name: "Popular Culture and Inequality",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3O03",
    name: "Qualitative Research Methods",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3P03",
    name: "Advanced Analysis of Contemporary Sociological Theory",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3QQ3",
    name: "Sociology Students and the Work World",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3RI3",
    name: "Racism and Racial Inequality",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3RR3",
    name: "Imprisonment",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3SS3",
    name: "Sociology of Judgement",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3U03",
    name: "Sociology of Sexualities",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3UU3",
    name: "Power, Conflict, and the Law",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3VV3",
    name: "The Indian Act: A Social Problem",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3W03",
    name: "Historical Methods in Sociology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "3YY3",
    name: "Sociology of Globalization",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4A03",
    name: "Ethnic/Racial Tensions",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4AA3",
    name: "Selected Topics in the Sociology of the Family",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4BB3",
    name: "Selected Topics in the Sociology of Education",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4CM3",
    name: "Critical Analysis of Media",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4DD3",
    name: "Social Movements and Social Change",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4E03",
    name: "Self and Identity",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4EE3",
    name: "Selected Topics in the Sociology of Culture",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4FF3",
    name: "Applications of Quantitative Methods in the Social Sciences",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4G03",
    name: "Advanced Topics in the Sociology of Health and Illness",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4GG3",
    name: "Special Topics in the Sociology of Deviance",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4J03",
    name: "Selected Topics in Sociology I",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4KK3",
    name: "Sociology through Community Engagement and Service",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4LL3",
    name: "Selected Topics in the Sociology of Immigration",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4M03",
    name: "Directed Research I for Honours Students",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4MM3",
    name: "Public Social Psychology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4MM6",
    name: "Directed Research for Honours Students",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4N03",
    name: "Directed Research II for Honours Students",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4NN3",
    name: "Meeting the Challenge of a Changing Climate",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4QQ3",
    name: "Women, Sexuality and the Welfare State",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4R03",
    name: "Individual and Society",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4RD3",
    name: "The Sociological Indian: What is reconciliation and decolonization and why does it matter?",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4RR3",
    name: "Indigenous Peoples and Canada",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4SI3",
    name: "Social Media, Sex, and Inequality in Intimate Relationships",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4SR3",
    name: "Topics in the Sociology of Religion",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4SS3",
    name: "The Sociology of the 1960s",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4U03",
    name: "Special Topics in the Sociology of Women",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4UU3",
    name: "Global Family and Sexual Politics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4V03",
    name: "Issues in the Sociology of Occupations and the Professions",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4W03",
    name: "Social Problems",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4XX3",
    name: "Sociology of At-Risk Youth",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4YY3",
    name: "Feminism and Social Policy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCIOL",
    code: "4ZZ3",
    name: "Selected Topics in Law and Society",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "1Z03",
    name: "An Introduction to Social Psychology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "2B03",
    name: "Psychology of Well-Being",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "2C03",
    name: "Social Psychology of Popular Culture",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "2D03",
    name: "Making and Breaking Rules",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "2E03",
    name: "Psychology of Intergroup Relations",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "2F03",
    name: "Psychology of Close Relationships",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "2K03",
    name: "Research Methods in Social Psychology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "2YY3",
    name: "Theories in Social Psychology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "3A03",
    name: "Mental Health",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "3B03",
    name: "Understanding Lived Experiences",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "3C03",
    name: "Regimes of Social Control",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "3E03",
    name: "Big Ideas/Great Thinkers in Social Psychology",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "3F03",
    name: "Who Am I? Self and Identity",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "3K03",
    name: "Research Experience",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "3L03",
    name: "Advanced Research Methods",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "3M03",
    name: "Counselling & Psychotherapy",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "3RR3",
    name: "Imprisonment",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "3Y03",
    name: "Social Psychology in Action",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "3ZZ3",
    name: "Small Worlds: Children and Childhood",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "4A03",
    name: "Advanced Research Experience",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "4B03",
    name: "Special Topics in Social Psychology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "4D03",
    name: "Contemporary Social Issues",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "4E03",
    name: "Special Topics in Social Psychology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "4F03",
    name: "Social Psychology of Crime and the Media",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "4G03",
    name: "Child Clinical Psychology",
    classification: "Psychology",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "4IS3",
    name: "Independent Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "4IS6",
    name: "Independent Research",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "4MM3",
    name: "Public Social Psychology",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCPSY",
    code: "4ZZ6",
    name: "Social Psychology Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "1HS3",
    name: "Pathways into the Social Sciences",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "1RM3",
    name: "How do we Know? Doing Social Sciences Research",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "1SS3",
    name: "Inquiry in the Social Sciences",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "1T03",
    name: "Life, the University, and Everything",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2AC3",
    name: "Financial & Managerial Accounting for Social Sciences",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2BA3",
    name: "Introduction to Business Analysis for Social Sciences",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2BR3",
    name: "Board and Staff Responsibilities for the Not-for-Profit Sector",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2BU3",
    name: "Introduction to Business for Social Sciences",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2CC3",
    name: "Children and Family in Canada",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2CP3",
    name: "Disability Management Capstone Project",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2EL0",
    name: "Career Preparation in the Social Sciences",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2EN3",
    name: "Entrepreneurial Training for Social Sciences",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2FD3",
    name: "Foundations of Disabilities",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2HR3",
    name: "Human Resources Management for Social Sciences",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2IS3",
    name: "Intervention Strategies Working with Disabilities",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2J03",
    name: "Introduction to Statistics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2JS1",
    name: "Co-Op Job Search 1",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2LC3",
    name: "Leadership and Communications for the Not-For-Profit Sector",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2LI3",
    name: "Legal Implications and Brain Disorders",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2MR3",
    name: "Introduction to Marketing for Social Sciences",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2N03",
    name: "Conspiracy Theories, Fake News and Critical Investigation",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2O03",
    name: "Canadian Children",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2OP3",
    name: "Operational Planning for the Not-For-Profit Sector",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2P03",
    name: "Canadian Adolescents",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2PN3",
    name: "Pharmacology for Non-Medical Health Professionals",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2RD3",
    name: "Resource Development for the Not-For-Profit Sector",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2SP3",
    name: "Strategic and Long Range Planning for the Not-for-Profit Sector",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2SS3",
    name: "Inquiry Thinking and Research Skills",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2WF3",
    name: "Working with Families with Disabilities",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "2WT0",
    name: "Social Sciences Co-Op Work Term",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "3EL3",
    name: "Leadership for Social Innovation",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "3EP3",
    name: "Social Sciences Experiential Project",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "3IF0",
    name: "Full-Time Internship",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "3IP0",
    name: "Part-Time Internship",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "3JS1",
    name: "Co-Op Job Search II",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "3WT0",
    name: "Social Sciences Co-Op Work Term",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "4JS1",
    name: "Co-Op Job Search III",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "4SI3",
    name: "Innovation for Social Impact",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCSCI",
    code: "4WT0",
    name: "Social Sciences Co-Op Work Term",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "1AA3",
    name: "So You Think You Can Help? Introduction to Social Work I",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "1BB3",
    name: "Re-Imagining Help: Introduction to Social Work II",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "2A06",
    name: "Theory, Process and Communication Skills for Social Work",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "2BB3",
    name: "Anti-Oppressive Social Work",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "2CC3",
    name: "Introduction to Community Practice",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "3C03",
    name: "Social Aspects of Health and Illness",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "3D06",
    name: "General Social Work I",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "3DD6",
    name: "Field Practicum I",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "3E03",
    name: "Individual Practice Across the Lifespan",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "3F03",
    name: "Social Work with Groups",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "3I03",
    name: "Social Work and Indigenous Peoples",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "3O03",
    name: "Social Work and Sexualities",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "3S03",
    name: "Social Work, Disability and Dis/Ableism",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "3T03",
    name: "Poverty and Homelessness",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "4C03",
    name: "Critical Perspectives on Race, Racialization, Racism and Colonialism in Canadian Society",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "4D06",
    name: "General Social Work II",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "4DD6",
    name: "Field Practicum II",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "4G03",
    name: "Selected Topics",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "4J03",
    name: "Social Change: Social Movements and Advocacy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "4QQ3",
    name: "Indigenizing Social Work Practice Approaches",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "4R03",
    name: "Feminist Approaches to Social Work and Social Justice",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "4SA3",
    name: "Critical Child Welfare: From Theory to Practice",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "4TI3",
    name: "Trauma Informed Practice",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "4U03",
    name: "Immigration, Settlement and Social Work",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "4W03",
    name: "Child Welfare",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "4X03",
    name: "Social Work with Families",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "4Y03",
    name: "Critical Issues in Mental Health & Addiction: Mad & Critical Disability Studies Perspectives for SW",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SOCWORK",
    code: "4ZZ3",
    name: "Social Welfare: Practice Implications and Advocacy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SPANISH",
    code: "1A03",
    name: "Intermediate Spanish I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SPANISH",
    code: "1AA3",
    name: "Intermediate Spanish II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SPANISH",
    code: "1Z06",
    name: "Beginners Intensive Spanish",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SPANISH",
    code: "2Z03",
    name: "Intermediate Spanish I",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SPANISH",
    code: "2ZZ3",
    name: "Intermediate Spanish II",
    classification: "Foreign Language",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "1LL3",
    name: "Introduction to Probability and Statistics",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "2B03",
    name: "Statistical Methods for Science",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "2D03",
    name: "Introduction to Probability",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "2DA3",
    name: "An Introduction to Data Science Methods",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "2MB3",
    name: "Statistical Methods and Applications",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "3A03",
    name: "Applied Regression Analysis with SAS",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "3D03",
    name: "Mathematical Statistics",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "3DA3",
    name: "Data Science Methods",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "3DS3",
    name: "Introduction to Data Science Theory",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "3G03",
    name: "Actuarial Mathematics I",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "3J04",
    name: "Probability and Statistics for Civil Engineering",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "3PG3",
    name: "Probability and Games of Chance",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "3S03",
    name: "Survey Sampling",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "3ST3",
    name: "Actuarial Models in Non-Life Insurance",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "3U03",
    name: "Stochastic Processes",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "3Y03",
    name: "Probability and Statistics for Engineering",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "4A03",
    name: "Time Series",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "4C03",
    name: "Generalized Linear Models",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "4CI3",
    name: "Computational Methods for Inference",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "4D03",
    name: "Intermediate Probability Theory",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "4G03",
    name: "Advanced Topics in Actuarial Science",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "4H03",
    name: "Actuarial Mathematics II",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "4I03",
    name: "Inference",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "4M03",
    name: "Multivariate Analysis",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "4P03",
    name: "Advanced Applied Statistics",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "4T06",
    name: "Senior Research Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "4W03",
    name: "Reading in Statistics",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STATS",
    code: "5GT3",
    name: "Graduate Level Topics in Statistics",
    classification: "Statistics",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "STEP",
    code: "1SP0",
    name: "Summer Transition English Prep",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SUSTAIN",
    code: "1S03",
    name: "Introduction to Sustainability",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SUSTAIN",
    code: "2GS3",
    name: "Global Questions in Sustainability",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SUSTAIN",
    code: "2IS3",
    name: "Intersectionality and Sustainable Development",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SUSTAIN",
    code: "2S03",
    name: "Evaluating Problems & Sustainable Solutions",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SUSTAIN",
    code: "2SD3",
    name: "Exploring the United Nations Sustainable Development Goals",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SUSTAIN",
    code: "2SS3",
    name: "Advocating for Sustainability",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SUSTAIN",
    code: "3S03",
    name: "Implementing Sustainable Change",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SUSTAIN",
    code: "3SS3",
    name: "Community Engagement and Prototyping for Sustainability",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "SUSTAIN",
    code: "4S06",
    name: "Leadership in Sustainability",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "2AA3",
    name: "Acting as Devising I",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "2BB3",
    name: "Designing for Devised Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "2CC3",
    name: "Performance, Art, and Visual Culture in Canada",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "2DP3",
    name: "Devised Performance Processes",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "2FA3",
    name: "Film Analysis",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "2MM3",
    name: "Movies and Me",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3AA3",
    name: "Modernist Drama and Theatre in Europe",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3DD3",
    name: "Contemporary Canadian Drama and Theatre",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3FF3",
    name: "Early Cinema History",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3L03",
    name: "Cinema History from WWII",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3N03",
    name: "Artists Alternative Film and Video",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3P03",
    name: "Gender and Visual Culture",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3PC3",
    name: "Performance and Community Engagement",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3PR3",
    name: "Text-based Devising: Research and Development",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3PS3",
    name: "Devising New Plays: Research and Development",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3QA3",
    name: "Documentary, Politics, and Social Change",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3RR3",
    name: "Cripping Performance: Deaf, Mad and Disabled Performance in Canada",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3S06",
    name: "Major Production Workshop",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3SD3",
    name: "Scripting the Devised Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3U03",
    name: "Pleasure and Critique in Dramatic Performance",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3VS3",
    name: "Visual Storytelling",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3WW3",
    name: "Acting and the Voice: Devising from Classical Texts",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3XX3",
    name: "Acting and the Body: Devising Physical Theatre",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "4A06",
    name: "Theatre and Society: A Performance Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "4C03",
    name: "Performance and Society",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "4D03",
    name: "Theatre, Society and Early Cinema",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "4E03",
    name: "Cinema and Society",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "THTRFLM",
    code: "3OP6",
    name: "Organizing the Performance Space",
    classification: "Art",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "TRONBME",
    code: "5P06",
    name: "Integrated Mechatronics & Biomedical Engineering Capstone Design Project",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WHMIS",
    code: "1A00",
    name: "Introduction to Health and Safety",
    classification: "Other",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "1A03",
    name: "An Introduction to Work and Labour in Canada",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "1D03",
    name: "Technology and the Future of Work",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "1E03",
    name: "Navigating the World of Work",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "2A03",
    name: "Unions in Action",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "2G03",
    name: "Labour and Globalization",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "2H03",
    name: "Sports, Work and Labour",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "2J03",
    name: "Work and Racism",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "2M03",
    name: "Pop Culture, Media and Work",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "2W03",
    name: "Human Rights and Social Justice",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "3A03",
    name: "Economics of Labour Market Issues",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "3B03",
    name: "Economics of Trade Unionism and Labour",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "3C03",
    name: "Labour and Employment Law",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "3D03",
    name: "Work: Dangerous to your Health?",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "3E03",
    name: "Gender, Sexuality and Work",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "3K03",
    name: "On the Move: Workers in a Global World",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "3L03",
    name: "Labour Policy and Advocacy",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "3M03",
    name: "Theoretical Approaches to Work and Labour Studies",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "3P03",
    name: "Workers Resistance",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "3Q03",
    name: "Community Engaged Research",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "3T03",
    name: "Poverty and Homelessness",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "4A06",
    name: "Work and Labour Studies Practicum",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "4C03",
    name: "Public Sector Collective Bargaining",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "4F03",
    name: "Work and the Environment",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "4G03",
    name: "Advanced Topics in Work and Labour Studies",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "4H03",
    name: "Working Precariously: Labour Strategies, Labour Renewal",
    classification: "Social Science",
    lab: "",
  },
  {
    university: "McMaster University",
    prefix: "WORKLABR",
    code: "4J03",
    name: "Independent Study",
    classification: "Social Science",
    lab: "",
  },
];

export default courses;
